$(document).ready(function () {
    $('.has-child').hover(
        function () {
            $('body').addClass('hovering');
        },
        function () {
            $('body').removeClass('hovering');
        }
    );

    $('.humberg-menu').click(function () {
        $('body').toggleClass('menu-open')
    });

    $('.nav-menu .nav-item.has-child .nav-link').click(function (e) {
        e.preventDefault();
        const $parent = $(this).parent('.nav-item');
        const $grandParent = $(this).closest('.nav-menu');

        $grandParent.toggleClass('submenu-open');
        $parent.toggleClass('open-submenu');
    });

    $(".discover-inner-cta").on("click", function () {
        var $col = $(this).closest(".discover-col");
        $col.siblings(".discover-col").removeClass("discover-active");
        $col.toggleClass("discover-active");
        // Scroll horizontally to the .discover-col
        var scrollContainer = $col.closest('.discover-block-content'); // change this selector to your actual scrollable parent

        if (scrollContainer.length) {
            scrollContainer.animate({
                scrollLeft: $col.position().left + scrollContainer.scrollLeft() - 20
            }, 500); // 500ms animation
        }
    });

    $(document).on("click", ".accordion-item:not(.no-click) .accordion-title", function () {
        var $item = $(this).closest(".accordion-item");
        var $list = $item.closest(".accordion-list");

        if ($item.hasClass("active")) {
            $item.removeClass("active")
                .find(".accordion-content").stop(true, true).slideUp();
        }

        else {
            $list.find(".accordion-item").removeClass("active")
                .find(".accordion-content").stop(true, true).slideUp();

            $item.addClass("active")
                .find(".accordion-content").stop(true, true).slideDown();
        }
    });

    let scrollPosition = 0;

    function disableBodyScroll() {
    scrollPosition = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '0';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    }

    function enableBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);
    }

    $(".radio-select-btn").on("click", function (e) {
        e.preventDefault();
        if ($(window).width() < 768) {
            $('body').addClass('overflow-hidden');
            disableBodyScroll();
        }
        $(".radio-select-dropdown").toggle();
        $(this).toggleClass("active", $(".radio-select-dropdown").is(":visible"));
    });

    $(".radio-select-dropdown .close-popup").on("click", function () { 
        $(".radio-select-dropdown").hide();
        if ($(window).width() < 768) {
            $('body').removeClass('overflow-hidden');
            enableBodyScroll();
        }
    }); 

    // Function to sync #SortBy select with selected radio
    function syncSortSelectWithRadio() {
        // Step 1: Get selected radio text
        const selectedRadioText = $('input[name="sort"]:checked').val();

        // Step 2: Find the <option> with matching visible text
        const matchingOption = $('#SortBy option').filter(function () {
            return $.trim($(this).data('text')) === $.trim(selectedRadioText);
        });

        if (matchingOption.length) {
            // Step 3: Set the select to the matching value and trigger change
            $('#SortBy').val(matchingOption.val()).change();
            // $('#SortBy option[data-text="'+$('input[name="sort"]:checked').val()+'"]').change();
        }
    }

    // Initial sync if needed
    syncSortSelectWithRadio();

    if ($('input[name="sort"]').length > 0 && $('input[name="sort"]:checked').length <= 0 )
       $('input[name="sort"]').val('In evidenza').click();

    // On radio button change
    $('input[name="sort"]').on('change', function () {
        $('input[name="sort"]').prop('checked', false);
        $(this).prop('checked', true);
        syncSortSelectWithRadio();
        if ($(window).width() < 768) {
            $('body').removeClass('overflow-hidden');
            enableBodyScroll();
        }
    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest(".radio-select").length) {
            $(".radio-select-dropdown").hide();
            $(".radio-select-btn").removeClass("active");
        }
    });

    $(function () {
        let currentIndex = 0;
        const texts = $(".slide-text .content");
        const images = $(".slide-image");
        const totalSlides = texts.length;
        let isAnimating = false;
        let inSlideSection = false;

        $(".total").text(totalSlides);

        const radius = 11;
        const circumference = 2 * Math.PI * radius;

        $(".progress-ring__circle").css({
            strokeDasharray: circumference,
            strokeDashoffset: circumference
        });

        function setProgress(percent) {
            const offset = circumference - (percent / 100) * circumference;
            $(".progress-ring__circle").css("stroke-dashoffset", offset);
        }

        function updateControls() {
            $(".prev").toggleClass("disabled", currentIndex === 0);
            $(".next").toggleClass("disabled", currentIndex === totalSlides - 1);
        }

        let scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        function disablePageScroll() {
            scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            $("body").css({
                overflow: "hidden",
                paddingRight: scrollBarWidth + "px"
            });
        }

        function enablePageScroll() {
            $("body").css({
                overflow: "auto",
                paddingRight: "0"
            });
        }

        function showSlide(index) {
            if (isAnimating) return;
            isAnimating = true;

            texts.stop(true, true);
            images.stop(true, true);

            texts.filter(".active").removeClass("active").fadeOut(200, function () {
                texts.eq(index).fadeIn(200, function () {
                    $(this).addClass("active");
                    isAnimating = false;
                });
            });

            images.filter(".active").removeClass("active").fadeOut(200, function () {
                images.eq(index).fadeIn(200).addClass("active");
            });

            $(".current").text(index + 1);
            setProgress(((index + 1) / totalSlides) * 100);
            updateControls();
        }

        // Detect if section is centered in viewport
        const $slideSection = $(".slide-section");
        function isSectionCentered() {
            const rect = $slideSection[0]?.getBoundingClientRect();
            if (!rect) return false;
            const viewportHeight = window.innerHeight;
            const sectionCenter = rect.top + rect.height / 2;
            const viewportCenter = viewportHeight / 2;
            return Math.abs(sectionCenter - viewportCenter) < 150;
        }

        // Mouse wheel control
        let wheelTimeout;
        $(window).on("wheel", function (e) {
            clearTimeout(wheelTimeout);
            wheelTimeout = setTimeout(() => {
                const delta = e.originalEvent.deltaY;
                const centered = isSectionCentered();

                if (centered && !inSlideSection) {
                    inSlideSection = true;
                    disablePageScroll();
                } else if (!centered && inSlideSection) {
                    inSlideSection = false;
                    enablePageScroll();
                }

                if (inSlideSection && !isAnimating) {
                    if (delta > 0 && currentIndex < totalSlides - 1) {
                        e.preventDefault();
                        currentIndex++;
                        showSlide(currentIndex);
                    } else if (delta < 0 && currentIndex > 0) {
                        e.preventDefault();
                        currentIndex--;
                        showSlide(currentIndex);
                    } else if (
                        (delta > 0 && currentIndex === totalSlides - 1) ||
                        (delta < 0 && currentIndex === 0)
                    ) {
                        inSlideSection = false;
                        enablePageScroll();
                    }
                }
            }, 80);
        });

        // ✅ Arrow controls
        $(".next").on("click", function () {
            if (currentIndex < totalSlides - 1 && !isAnimating) {
                currentIndex++;
                showSlide(currentIndex);
            }
        });

        $(".prev").on("click", function () {
            if (currentIndex > 0 && !isAnimating) {
                currentIndex--;
                showSlide(currentIndex);
            }
        });

        // Init
        texts.hide().eq(currentIndex).show().addClass("active");
        images.hide().eq(currentIndex).show().addClass("active");
        setProgress(((currentIndex + 1) / totalSlides) * 100);
        updateControls();
    });


    const $dropdownLabel = $(".dropdown-label");
    const $dropdownList = $(".collection-category-list");

    $dropdownLabel.on("click", function (e) {
        e.stopPropagation();
        if ($(window).width() < 768) {
            $('body').addClass('overflow-hidden');
            disableBodyScroll();
        }
        $dropdownList.toggleClass("open");
        $dropdownLabel.toggleClass("active");
    });

    $('.collection-category-header .close-cat').click(function() {
        $('.collection-category-list').removeClass('open');
        $(".dropdown-label").removeClass('active');
        if ($(window).width() < 768) {
            $('body').removeClass('overflow-hidden');
            enableBodyScroll();
        }
    });

    $(document).on("click", function () {
        $dropdownList.removeClass("open");
        $dropdownLabel.removeClass("active");
    });

    $dropdownList.on("click", function (e) {
        e.stopPropagation();
    });

    const section = document.querySelector('.discover-block-content');
    if (section) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0
        });
        observer.observe(section);
    }

    $(".tab-link").click(function () {
        var tabID = $(this).data("tab");
        $(".tab-link").removeClass("active");
        $(this).addClass("active");
        $(".tab-content").removeClass("active");
        $("#" + tabID).addClass("active");
    });

    $("#sidebarToggle").on("click", function () {
        $(this).toggleClass('active-btn')
        $(".blog-sidebar-menu").slideToggle(200);
    });

    if ($(window).width() < 992) {
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.blog-sidebar-menu').length && !$(e.target).closest('.blog-sidebar').length) {
                // Click was outside .blog-sidebar-menu
                $(".blog-sidebar-menu").slideUp(200);
            }
        });
    }

    $(".blog-sidebar-menu a").on("click", function (e) {
        e.preventDefault();

        $(".blog-sidebar-menu a").removeClass("active");
        $(this).addClass("active");

        $("#activeLinkText").text($(this).text());

        $(".sidebar-menu").slideUp(200);

        const target = $($(this).attr("href"));
        if (target.length) {
            $("html, body").animate({
                scrollTop: target.offset().top - 20
            }, 'fast');
        }
        $(".blog-sidebar-menu").slideToggle(200);
    });


    if ($('.blog-post-block h2').length > 0) {
        $('.blog-post-block h2').each(function () {
            $(this).replaceWith(function () {
                return $('<h4>').html($(this).html());
            });
        });

        $('.blog-post-block h3').each(function () {
            $(this).replaceWith(function () {
                return $('<h6>').html($(this).html());
            });
        });
    }

    if ($('.blog-post-block h4').length > 0) {
        // Step 1: Add IDs to h4 and h6
        $('.blog-post-block h4').each(function (i) {
            $(this).attr('id', 'heading-h4-' + (i + 1));
        });
        $('.blog-post-block h6').each(function (i) {
            $(this).attr('id', 'heading-h6-' + (i + 1));
        });

        // Step 2: Build the sidebar menu ul
        let $menu = $('.no-list.blog-sidebar-menu');

        // We'll iterate over h4 elements and find subsequent h6 elements until next h4
        $('.blog-post-block h4').each(function (i, h4) {
            let $h4 = $(h4);
            let h4Id = $h4.attr('id');
            let h4Text = $h4.text();

            // Create top-level li with link
            let $li = $('<li></li>');
            let $a = $('<a></a>').attr('href', '#' + h4Id).text(h4Text);
            $li.append($a);

            // Find all h6 after this h4 until next h4
            let $nextElements = $h4.nextUntil('h4');
            if ($nextElements.length === 0) {
                // No next h4, so grab all siblings after current h4
                $nextElements = $h4.nextAll();
            }
            let $h6s = $nextElements.filter('h6');

            if ($h6s.length) {
                // Add class and sub-link toggle div (optional, as in your example)
                $li.addClass('has-child-list');
                let $toggleBtn = $('<div id="blog-sub-link-btn" class="blog-sub-link-btn"><span></span></div>');
                $li.append($toggleBtn);

                // Create nested ul for h6
                let $childUl = $('<ul class="child-links no-list"></ul>');
                $h6s.each(function (j, h6) {
                    let $h6 = $(h6);
                    let h6Id = $h6.attr('id');
                    let h6Text = $h6.text();

                    let $childLi = $('<li></li>');
                    let $childA = $('<a></a>').attr('href', '#' + h6Id).text(h6Text);
                    $childLi.append($childA);

                    $childUl.append($childLi);
                });

                $li.append($childUl);
            }

            // Append this li to menu ul
            $menu.append($li);
        });
    }

    $(".faq-links a").on("click", function (e) {
        e.preventDefault();

        $(".faq-links a").removeClass("active");
        $(this).addClass("active");

        const target = $($(this).attr("href"));
        if (target.length) {
            $("html, body").animate({
                scrollTop: target.offset().top - 20
            }, 'fast');
        }
    });

    if ($('.page-block h2').length > 0) {
        $('.page-block h2').each(function () {
            $(this).replaceWith(function () {
                return $('<h4>').html($(this).html());
            });
        });

        $('.page-block h3').each(function () {
            $(this).replaceWith(function () {
                return $('<h6>').html($(this).html());
            });
        });
    }

    if ($('.page-block h4').length > 0) {
        // Step 1: Add IDs to h4 and h6
        $('.page-block h4').each(function (i) {
            $(this).attr('id', 'heading-h4-' + (i + 1));
        });
        $('.page-block h6').each(function (i) {
            $(this).attr('id', 'heading-h6-' + (i + 1));
        });

        // Step 2: Build the sidebar menu ul
        let $menu = $('.no-list.blog-sidebar-menu');

        // We'll iterate over h4 elements and find subsequent h6 elements until next h4
        $('.page-block h4').each(function (i, h4) {
            let $h4 = $(h4);
            let h4Id = $h4.attr('id');
            let h4Text = $h4.text();

            // Create top-level li with link
            let $li = $('<li></li>');
            let $a = $('<a></a>').attr('href', '#' + h4Id).text(h4Text);
            $li.append($a);

            // Find all h6 after this h4 until next h4
            let $nextElements = $h4.nextUntil('h4');
            if ($nextElements.length === 0) {
                // No next h4, so grab all siblings after current h4
                $nextElements = $h4.nextAll();
            }
            let $h6s = $nextElements.filter('h6');

            if ($h6s.length) {
                // Add class and sub-link toggle div (optional, as in your example)
                $li.addClass('has-child-list');
                let $toggleBtn = $('<div id="blog-sub-link-btn" class="blog-sub-link-btn"><span></span></div>');
                $li.append($toggleBtn);

                // Create nested ul for h6
                let $childUl = $('<ul class="child-links no-list"></ul>');
                $h6s.each(function (j, h6) {
                    let $h6 = $(h6);
                    let h6Id = $h6.attr('id');
                    let h6Text = $h6.text().replace(/^\d+\.\s*/, '');

                    let $childLi = $('<li></li>');
                    let $childA = $('<a></a>').attr('href', '#' + h6Id).text(h6Text);
                    $childLi.append($childA);

                    $childUl.append($childLi);
                });

                $li.append($childUl);
            }

            // Append this li to menu ul
            $menu.append($li);
        });
    }

    $(".blog-sub-link-btn").on("click", function () {
        $(this).toggleClass('active-link-btn')
        $(this).next(".child-links").slideToggle(200);
    });

    const sections = $("section, section div[id], .blog-post-block h4, .blog-post-block h6, .faq-link-content .faq-link-content-inner:visible, .page-block h4, .page-block h6");
    // const sections = $(".blog-post-block h4, .blog-post-block h6, .faq-link-content .faq-link-content-inner:visible, .page-block h4");
    const navLinks = $(".blog-sidebar a, .faq-links a");

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    // Get first and last h4 in .main-section
    const $firstH4 = $('.main-section h4').first();
    const $lastH4 = $('.main-section h4').last();

    // Function to check both
    function checkHeadingsInView() {
        if ($firstH4.length > 0) {
            if (isInViewport($firstH4[0])) {
                $('.blog-sidebar-menu li a').removeClass('active');
                $('.blog-sidebar-menu > li:first-child a').addClass('active');
            }
        }

        if ($lastH4.length > 0) {
            if (isInViewport($lastH4[0])) {
                $('.blog-sidebar-menu li a').removeClass('active');
                $('.blog-sidebar-menu > li:last-child a').addClass('active');
            }
        }
    }

    $(window).on("scroll", function () {
        const $searchInput_scroll = $('input[name="faq-search"]');
        if ($searchInput_scroll.length <= 0 || $searchInput_scroll.val() == '') {
            let current = "";
            sections.each(function () {
                const sectionTop = $(this).offset().top - 120;
                if ($(window).scrollTop() >= sectionTop) {
                    current = $(this).attr("id");
                }
            });

            navLinks.removeClass("active");

            if (current) {
                if ($('.blog-sidebar').length > 0) {
                    var activeLink = $('.blog-sidebar a[href="#' + current + '"]');
                } else {
                    var activeLink = $('.faq-links li a[href="#' + current + '"]');
                }
                activeLink.addClass("active");

                const parentLink = activeLink.closest("ul").parent("li").children("a");
                parentLink.addClass("active");
            }

            if ($('.blog-sidebar-menu li a.active').length <= 0)
                checkHeadingsInView();

            if ($('.faq-links li a.active').length <= 0) {
                // $('.faq-links > li:first-child a').addClass('active');
                // $('.faq-links > li a').removeClass('active');
                $('.faq-links > li:visible:eq(0) a').addClass('active');
            }
        }
    });

    $('.blog-sidebar-menu > li:first-child a').addClass('active');
    $('.faq-links > li:first-child a').addClass('active');

    navLinks.on("click", function (e) {
        e.preventDefault();
        navLinks.removeClass("active");

        $(this).addClass("active");
        $(this).closest("ul").parent("li").children("a").addClass("active");

        const target = $($(this).attr("href"));
        if (target.length) {
            $("html, body").animate({
                scrollTop: target.offset().top - 20
            }, 'fast');
        }

        $("#activeLinkText").text($(this).text());

        if ($(window).width() <= 991) {
            $(".blog-sidebar-menu")?.slideToggle(200);
        }
    });


    $("#start-quiz").click(function () {
        $(".quiz-landing-section").hide();
        $(".quiz-question-section").fadeIn();
        $('.step-que-1').addClass('active');
        $(".bake-link").fadeIn();
    });

    $('.quiz-close').on('click', function () {
        $('#thankYouModal').fadeIn();
    });

    $('#reload-btn').on('click', function () {
        $('#thankYouModal').fadeOut();
        $('.quiz-question-section').fadeOut();
        $('.customize-selection').fadeOut();
        $('.quiz-questions .question').removeClass('active');
        $('.next-btn').addClass('disabled');
        $('.quiz-landing-section').fadeIn();
        $('.quiz-question-section input').prop('checked', false);
        // Clear all step-related sessionStorage keys on load
        Object.keys(sessionStorage).forEach(function (key) {
            if (
                key === 'quizStep_1' ||
                key.startsWith('quizStep_2_') ||
                key.startsWith('quizStep_2-subStep_') ||
                key === 'quizStep_3'
            ) {
                sessionStorage.removeItem(key);
                console.log(`🗑️ Removed sessionStorage key: ${key}`);
            }
        });
        $(".progress-line").css("width", "0%");
        visibleSteps = [];
        historyStack = [];
    });

    let matchingStep2Elements = [];
    let currentStep2Index = 0;
    let visibleSteps = []; // This tracks the actual flow (including sub-questions)
    let historyStack = [];

    // ===== PROGRESS UPDATE =====
    function updateProgress() {
        const currentIndex = historyStack.length;
        const total = visibleSteps.length;
        const percent = (currentIndex / total) * 100;
        $(".progress-line").css("width", percent + "%");
    }

    // ===== Enable Next Button if Option Selected =====
    function enableNextIfAnswerSelected($question) {
        const hasChecked = $question.find('input[type="radio"]:checked, input[type="checkbox"]:checked').length > 0;
        const $nextBtn = $question.find('.next-btn');
        if ($nextBtn.length === 0) return;
        $nextBtn.prop('disabled', !hasChecked).toggleClass('disabled', !hasChecked);
    }

    // ===== When user selects something, enable Next =====
    $(document).on('change', '.question input', function () {
        const $question = $(this).closest('.question');
        enableNextIfAnswerSelected($question);
    });

    // ===== NEXT BUTTON CLICK =====
    $(document).on('click', '.next-btn', function () {
        if ($(this).hasClass('disabled')) return;

        const $currentQuestion = $(this).closest('.question');
        $currentQuestion.removeClass('active');

        historyStack.push($currentQuestion); // Push current to history

        // STEP 1 → collect matching step-que-2s
        if ($currentQuestion.hasClass('step-que-1')) {
            matchingStep2Elements = [];
            visibleSteps = [];

            $('[name="question-1"]:checked').each(function () {
                const tag = $(this).attr('data-tag-step-1');
                const matches = $('.step-que-2[data-tag="' + tag + '"]');
                matches.each(function () {
                    matchingStep2Elements.push($(this));
                    visibleSteps.push($(this));
                });

                // check for sub-question
                const $subQ = $('.sub-question[data-parent-tag="' + tag + '"]');
                if ($subQ.length) {
                    visibleSteps.push($subQ);
                }
            });

            // Add step-que-3 at the end
            visibleSteps.push($('.step-que-3'));

            // Show first step-que-2
            if (matchingStep2Elements.length > 0) {
                const $next = matchingStep2Elements[0];
                $next.addClass('active');
                enableNextIfAnswerSelected($next);
                currentStep2Index = 1;
            } else {
                $('.step-que-3').addClass('active');
                enableNextIfAnswerSelected($('.step-que-3'));
            }

            updateProgress();
        }

        // If it's a sub-question or step-que-2
        else if ($currentQuestion.hasClass('step-que-2') || $currentQuestion.hasClass('sub-question')) {

            // Show next in visibleSteps
            const nextStep = visibleSteps[historyStack.length - 1];
            if (nextStep && nextStep.length) {
                nextStep.addClass('active');
                enableNextIfAnswerSelected(nextStep);
                updateProgress();
            } else {
                // If done with all steps, show customize
                $(".customize-selection").fadeIn();
                $(".progress-line").css("width", "100%");
            }
        }

        // STEP 3 → Customize Section
        else if ($currentQuestion.hasClass('step-que-3')) {
            $(".question").removeClass('active');
            $(".customize-selection").fadeIn();
            $(".progress-line").css("width", "100%");
            $(".bake-link").fadeOut();
        }
    });

    $(document).on('change', '.quiz-question-section input[type="radio"], .quiz-question-section input[type="checkbox"]', function () {
        const $input = $(this);
        const $question = $input.closest('.question');

        let storageKey = '';
        let selectedTags = [];

        // === STEP 1 ===
        if ($question.hasClass('step-que-1')) {
            storageKey = 'quizStep_1';

            // Get selected tags
            $('[name="question-1"]:checked').each(function () {
                const tag = $(this).data('tag-step-1');
                if (tag) selectedTags.push(tag);
            });

            // Handle UNCHECK - clean session and inputs of related step 2/sub-step
            if (!$input.is(':checked')) {
                const removedTag = $input.data('tag-step-1');

                if (removedTag) {
                    const step2Key = 'quizStep_2_' + removedTag;
                    const subStep2Key = 'quizStep_2-subStep_' + removedTag;

                    // Remove sessionStorage
                    sessionStorage.removeItem(step2Key);
                    sessionStorage.removeItem(subStep2Key);
                    console.log(`🗑️ Removed related ${step2Key}`);
                    console.log(`🗑️ Removed related ${subStep2Key}`);

                    // Uncheck Step 2 inputs with matching data-tag
                    $(`.step-que-2[data-tag="${removedTag}"] input[type="radio"], 
                    .step-que-2[data-tag="${removedTag}"] input[type="checkbox"],
                    .step-que-2-sub-que[data-parent-tag="${removedTag}"] input[type="radio"],
                    .step-que-2-sub-que[data-parent-tag="${removedTag}"] input[type="checkbox"]`)
                        .prop('checked', false);

                    console.log(`🔄 Unchecked inputs in Step 2 and Sub-Step 2 for tag "${removedTag}"`);
                }
            }

            // === STEP 2 ===
        } else if ($question.hasClass('step-que-2')) {
            const tagKey = $question.data('tag');
            if (!tagKey) return;
            storageKey = 'quizStep_2_' + tagKey;

            $question.find('input[type="radio"]:checked, input[type="checkbox"]:checked').each(function () {
                const tag = $(this).data('tag-step-2');
                if (tag) selectedTags.push(tag);
            });

            // === STEP 2 - SUB ===
        } else if ($question.hasClass('step-que-2-sub-que')) {
            const tagKey = $question.data('parent-tag');
            if (!tagKey) return;
            storageKey = 'quizStep_2-subStep_' + tagKey;

            $question.find('input[type="radio"]:checked, input[type="checkbox"]:checked').each(function () {
                const tag = $(this).data('tag-step-2');
                if (tag) selectedTags.push(tag);
            });

            // === STEP 3 ===
        } else if ($question.hasClass('step-que-3')) {
            storageKey = 'quizStep_3';
            $question.find('input[type="radio"]:checked, input[type="checkbox"]:checked').each(function () {
                const tag = $(this).data('tag-step-3');
                if (tag) selectedTags.push(tag);
            });
        }

        // === Store or Remove ===
        if (storageKey) {
            if (selectedTags.length > 0) {
                sessionStorage.setItem(storageKey, selectedTags.join(','));
                console.log(`✅ Stored ${storageKey}: ${selectedTags.join(',')}`);
            } else {
                sessionStorage.removeItem(storageKey);
                console.log(`🗑️ Removed ${storageKey}`);
            }
        }
    });

    // // Clear all step-related sessionStorage keys on load
    // Object.keys(sessionStorage).forEach(function (key) {
    //     if (
    //         key === 'quizStep_1' ||
    //         key.startsWith('quizStep_2_') ||
    //         key.startsWith('quizStep_2_subStep_') ||
    //         key === 'quizStep_3'
    //     ) {
    //         sessionStorage.removeItem(key);
    //         console.log(`🗑️ Removed sessionStorage key: ${key}`);
    //     }
    // });

    // ===== GLOBAL BACK BUTTON =====
    $(".back-btn").click(function () {
        const $current = $('.question.active');
        if ($current.length) $current.removeClass('active');

        $(".customize-selection").hide();

        // If history stack is empty, go back to landing section
        if (historyStack.length === 0) {
            $('.quiz-landing-section').fadeIn();
            $('.quiz-question-section').fadeOut();
            $(".progress-line").css("width", "0%");            
            $('.next-btn').addClass('disabled');
            $('.quiz-question-section input').prop('checked', false);
            // Clear all step-related sessionStorage keys on load
            Object.keys(sessionStorage).forEach(function (key) {
                if (
                    key === 'quizStep_1' ||
                    key.startsWith('quizStep_2_') ||
                    key.startsWith('quizStep_2-subStep_') ||
                    key === 'quizStep_3'
                ) {
                    sessionStorage.removeItem(key);
                    console.log(`🗑️ Removed sessionStorage key: ${key}`);
                }
            });
            return;
        }

        const $prev = historyStack.pop();
        $prev.addClass('active');
        enableNextIfAnswerSelected($prev);

        updateProgress();
    });


    // ===== INIT =====
    $('.next-btn').prop('disabled', true).addClass('disabled');
    enableNextIfAnswerSelected($('.step-que-1'));

    // const emailInput_quiz = document.querySelector('.customize-selection [type="email"]');
    // if (emailInput_quiz) {
    //     emailInput_quiz.addEventListener('input', function() {
    //         const email_quiz = emailInput_quiz.value.trim();
    //         const isValid_quiz = emailRegex.test(email_quiz);

    //         if (!isValid_quiz) {
    //             document.querySelector('.customize-selection form .results-btn').setAttribute('disabled', 'disabled');
    //         } else {
    //             document.querySelector('.customize-selection form .results-btn').removeAttribute('disabled');
    //         }
    //     });
    // }

    const emailInput_quiz = document.querySelector('.customize-selection [type="email"]');
    const nameInput_quiz = document.querySelector('.customize-selection [name="name"]');
    const resultsBtn = document.querySelector('.customize-selection form .results-btn');

    // const nameRegex = /^[a-zA-Z\s]{2,}$/; // Adjust name pattern as needed

    function validateInputs() {
        const email_quiz = emailInput_quiz?.value.trim() || '';
        const name_quiz = nameInput_quiz?.value.trim() || '';

        const isEmailValid = emailRegex.test(email_quiz);

        if (isEmailValid && name_quiz !== '') {
            resultsBtn?.removeAttribute('disabled');
        } else {
            resultsBtn?.setAttribute('disabled', 'disabled');
        }
    }

    if (emailInput_quiz) {
        emailInput_quiz.addEventListener('input', validateInputs);
    }
    if (nameInput_quiz) {
        nameInput_quiz.addEventListener('input', validateInputs);
    }

    $('.results-btn.email-required').on('click', function (e) {
        e.preventDefault();

        const resultsTargetListId = 'SZPDTB';
        const email_results = document.querySelector('.customize-selection-group [name="email"]').value;
        const name_results = document.querySelector('.customize-selection-group [name="name"]').value;

        // Get combined tags from step 2
        // const combinedTagsStep2 = Object.keys(sessionStorage)
        //     .filter(key => key.startsWith('quizStep_2_') && !key.startsWith('quizStep_2-subStep_'))
        //     .map(key => sessionStorage.getItem(key))
        //     .filter(Boolean)
        //     .join(',');

        // // Get combined tags from step 2 sub-steps
        // const combinedTagsSubStep2 = Object.keys(sessionStorage)
        //     .filter(key => key.startsWith('quizStep_2-subStep_'))
        //     .map(key => sessionStorage.getItem(key))
        //     .filter(Boolean)
        //     .join(',');

        // // Get individual step values
        // const step1 = sessionStorage.getItem('quizStep_1');
        // const step3 = sessionStorage.getItem('quizStep_3');

        // // Collect non-empty parts
        // const quizTagParts = [];

        // if (step1) quizTagParts.push(step1);
        // if (combinedTagsStep2) quizTagParts.push(combinedTagsStep2);
        // if (combinedTagsSubStep2) quizTagParts.push(combinedTagsSubStep2);
        // if (step3) quizTagParts.push(step3);

        // // Final result
        // const quizTags = quizTagParts.join(' - ');
        // console.log('✅ Final quizTags:', quizTags);

        // Step 1: Create the object for request body
        const requestData = {
            name: name_results,
            email: email_results,
            listId: resultsTargetListId
        };

        // Step 1 Tags with index
        const step1Tags = sessionStorage.getItem('quizStep_1');
        if (step1Tags) {
            const step1Array = step1Tags.split(',').map(tag => tag.trim());

            step1Array.forEach((tag, index) => {
                requestData[`Step 1 - ${index + 1}`] = tag;

                // Step 2 for each Step 1 tag with index
                const step2Key = `quizStep_2_${tag}`;
                const step2Value = sessionStorage.getItem(step2Key);
                if (step2Value) {
                    // If multiple values possible in step2Value, split and index them
                    const step2Array = step2Value.split(',').map(v => v.trim());
                    step2Array.forEach((val, idx) => {
                        requestData[`Step 2 ${tag} - ${idx + 1}`] = val;
                    });
                }

                // Substep 2 for each Step 1 tag with index
                const subStepKey = `quizStep_2-subStep_${tag}`;
                const subStepValue = sessionStorage.getItem(subStepKey);
                if (subStepValue) {
                    const subStepArray = subStepValue.split(',').map(v => v.trim());
                    subStepArray.forEach((val, idx) => {
                        requestData[`Substep 2 ${tag} - ${idx + 1}`] = val;
                    });
                }
            });
        }

        // Step 3 Tags with index (if multiple comma separated)
        const step3 = sessionStorage.getItem('quizStep_3');
        if (step3) {
            const step3Array = step3.split(',').map(tag => tag.trim());
            step3Array.forEach((tag, index) => {
                requestData[`Step 3 - ${index + 1}`] = tag;
            });
        }

        // Send request if email present
        if (email_results !== '') {
            const response = fetch('https://practicals.equest.solutions/Eusphera/subscribe-results.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestData)
            })
                .then(res => res.json())
                .then(data => {
                    // var success_redirect = '?customer_posted=true#newsletter-form-footer';
                    if (data.success) {
                        // Redirect after successful subscription
                        // window.location.href = window.location.pathname + success_redirect;
                        console.log('Successfully subscribed to newsletter!')
                    } else if (!data.success) {
                        // alert(data.error); // optional: show error
                        console.log(data.error)
                    }
                })
                .catch(err => console.error(err));
        }

        resultsTagsRedirection();

    });

    $('.results-btn').on('click', function (e) {
        e.preventDefault();
        resultsTagsRedirection();
    });

    function resultsTagsRedirection() {
        let selectedTags = [];

        $('input[name="question-1"]:checked').each(function () {
            const mainTag = $(this).data('tag-step-1');

            // Check if sub-question exists
            const $subQuestion = $('.step-que-2-sub-que[data-parent-tag="' + mainTag + '"]');

            if ($subQuestion.length) {
                // Sub-question exists → use related step-que-2 input's tag instead
                let step2TagFound = false;

                // Find the matching step-que-2 block
                const $step2Block = $('.step-que-2[data-tag="' + mainTag + '"]');

                if ($step2Block.length) {
                    $step2Block.find('input[type="radio"]:checked, input[type="checkbox"]:checked').each(function () {
                        const tag = $(this).data('tag-step-2');
                        if (tag) {
                            selectedTags.push(tag);
                            step2TagFound = true;
                        }
                    });
                }

                // If nothing selected in step-que-2, skip this main tag
                if (!step2TagFound) {
                    return; // skip this one
                }

            } else {
                // No sub-question → use main tag directly
                selectedTags.push(mainTag);
            }
        });

        let product_tag = selectedTags.join('+');

        Object.keys(sessionStorage).forEach(function (key) {
            if (
                key === 'quizStep_1' ||
                key.startsWith('quizStep_2_') ||
                key.startsWith('quizStep_2-subStep_') ||
                key === 'quizStep_3'
            ) {
                sessionStorage.removeItem(key);
                console.log(`🗑️ Removed sessionStorage key: ${key}`);
            }
        });

        var results_page;
        var results_page_prefix = "/pages/results?product_tag=" + product_tag;
        if (window.location.pathname.split('/pages')[0] != '') {
            results_page = window.location.pathname.split('/pages')[0] + results_page_prefix;
        } else {
            results_page = results_page_prefix;
        }

        document.querySelector('.customize-selection-group [name="email"]').value = '';
        document.querySelector('.customize-selection-group [name="name"]').value = '';

        window.location.href = results_page;
    }

    $('.quiz-questions input:checked').prop('checked', false);
    $('.quiz-questions .next-btn').addClass('disabled');

    if (document.querySelector('.customize-selection-group [name="email"]')) {
        document.querySelector('.customize-selection-group [name="email"]').value = '';
    }

    if (document.querySelector('.customize-selection-group [name="name"]')) {
        document.querySelector('.customize-selection-group [name="name"]').value = '';
    }
    // $('[name="result-product"]').click(function() {
    //     var price_total = 0;
    //     var compareprice_total = 0;
    //     var currencyMatch;
    //     var currencySymbol;
    //     if ($('[name="result-product"]:checked').length <= 0) {
    //         $('.price-value .variant-price').text($('.price-value .variant-price').attr('data-default-price'))
    //     } else {
    //         $('[name="result-product"]').each(function() {
    //             if($(this).is(':checked')) {
    //                 // const data_varaint_price = $(this).attr('data-variant-price').match(/[\d.,]+/);
    //                 // const extractedPrice = data_varaint_price ? data_varaint_price[0] : null;            
    //                 // console.log(extractedPrice)
    //                 // price_total = price_total + parseFloat(extractedPrice);

    //                 var priceText = $(this).attr('data-variant-price');

    //                 // Extract currency symbol: anything NOT a digit, comma, or dot
    //                 currencyMatch = priceText.match(/[^\d.,\s]+/g);
    //                 currencySymbol = currencyMatch ? currencyMatch[0] : '';


    //                 // Match the first number-like string (supports both 29,90 and 29.90)
    //                 var match = priceText.match(/[\d.,]+/);
    //                 if (!match) return null;

    //                 var raw = match[0];

    //                 // Handle different formats:
    //                 // "1.234,56" (EU) => 1234.56
    //                 // "1,234.56" (US) => 1234.56
    //                 // "29,90"        => 29.90
    //                 // "29.90"        => 29.90
    //                 if (raw.includes(',') && raw.includes('.')) {
    //                     if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) {
    //                     // Format: 1.234,56
    //                     raw = raw.replace(/\./g, '').replace(',', '.');
    //                     } else {
    //                     // Format: 1,234.56
    //                     raw = raw.replace(/,/g, '');
    //                     }
    //                 } else if (raw.includes(',')) {
    //                     // Only comma, treat as decimal separator
    //                     raw = raw.replace(',', '.');
    //                 }

    //                 var number = parseFloat(raw);

    //                 price_total = price_total + parseFloat(number);
    //             }
    //         })
    //         $('.price-value .variant-compareprice').addClass('hidden');
    //         $('.price-value .variant-price').text(currencySymbol+price_total.toFixed(2))
    //         // if ($(this).attr('data-variant-price').length > 0) {
    //         //     $('.price-value .variant-compareprice').text($(this).attr('data-variant-compare-price'))
    //         //     $('.price-value .variant-compareprice').removeClass('hidden');
    //         // }
    //     }
    // });


    $(document).on('click', '.results-products .product-image a', function (e) {
        e.preventDefault();
        $(this).parents('.products-item').find('input[type="checkbox"]').click();
    });

    if ($('body').hasClass('product')) {
        $(document).on('click', '[name="bundle-product"]', function (e) {
            if ($('[name="bundle-product"]:checked').length <= 0) {
                $('.bundle-add-to-cart').addClass('disabled');
            } else {
                $('.bundle-add-to-cart').removeClass('disabled');
            }

            const isChecked = $(this).is(':checked');

            // Get href from custom product
            const productHref = $(this).closest('.products-item').find('.product-title').attr('href');

            // Loop through all checkboxes in the app
            if (window.innerWidth > 990) {
                var BundleItems_item_wrapper = $('[class^="horizontalBundleItems_item_wrapper"]');
            } else {
                var BundleItems_item_wrapper = $('[class^="verticalBundleItems_item_wrapper"]');
            }
            BundleItems_item_wrapper.each(function () {
                const appHref = $(this).find('a').attr('href');
                if (appHref === productHref) {
                    if (window.innerWidth > 990) {
                        $(this).find('input[type="checkbox"]').parent().trigger('click');
                    } else {
                        $(this).find('[class^="verticalBundleItems_thumbnail_wrapper"]').trigger('click');
                    }
                    // $(this).find('input[type="checkbox"]').prop('checked', isChecked).trigger('change');

                    setTimeout(() => {
                        // Call the function to update the total price
                        updateTotalPrice();
                    }, 1500);
                }
            });

        });

        $(document).on('click', '.bundle-add-to-cart', function (e) {
            e.preventDefault();

            $(this).addClass('disabled').addClass('adding-to-cart');
            $(this).find('.loading__spinner').removeClass('hidden');

            $('.rbr-addBundleBtn-container').trigger('click');

            var addTocartDisabledInterval = setInterval(() => {
                if ($('.rbr-addBundleBtn-container .rbr-loader').length <= 0) {
                    $(this).removeClass('disabled').removeClass('adding-to-cart');
                    $(this).find('.loading__spinner').addClass('hidden');

                    fetch('/cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            const count = cart.item_count;
                            document.querySelector('.cart-count-bubble span') && 
                            (document.querySelector('.cart-count-bubble span').textContent = cart.item_count);

                            document.querySelector('.cart-count-bubble') && 
                            (document.querySelector('.cart-count-bubble').setAttribute('data-item-count', cart.item_count));
                        })
                        .catch(error => {
                            console.error('Error fetching cart count:', error);
                        });
                    clearInterval(addTocartDisabledInterval);
                }
            }, 200);
        });

        var qtyBundlemLTextInterval = setInterval(() => {
            if (document.querySelectorAll('[data-rbrselector="discountOptionV4"]').length > 0) {
                document.querySelectorAll('[data-rbrselector="discountOptionV4"]').forEach((product, index) => {
                    const cpsEl = document.querySelector('.product product-info .product-meta .cps');
                    if (!cpsEl) return;

                    const cpsText = cpsEl.textContent.trim(); // e.g., "10 mL | 1 fl. oz"
                    // const match = cpsText.match(/(\d+\s?mL)/i); // extract "10 mL"
                    const match = cpsText.split('|'); // extract "10 mL"
                    const matched = match[0].split(':');
                    var doseSize;
                    if (matched.length > 1) {
                        doseSize = matched ? matched[1] : '10 mL';
                    } else {
                        doseSize = matched ? matched[0] : '10 mL';
                    }

                    const quantity = index + 1; // 1, 2, 3...
                    if (Shopify.locale == 'de') {
                        var middle_text = 'Spender';
                    } else if (Shopify.locale == 'fr') {
                        var middle_text = 'distributeur';
                    } else if (Shopify.locale == 'es') {
                        var middle_text = 'dispensador';
                    } else if (Shopify.locale == 'it') {
                        var middle_text = 'dosatore';
                    } else {
                        var middle_text = 'Dispenser';
                    }

                    const contentValue = `${quantity} x ${middle_text} ${doseSize}`;

                    // Create a unique class to target the correct span
                    const span = document.querySelectorAll(
                        '[data-rbrselector="discountOptionV4"] [data-rbrselector="discountInfoV3Description"] > span'
                    )[index];

                    if (!span) return;

                    const uniqueClass = `custom-dose-${index}`;
                    span.classList.add(uniqueClass);

                    // Create style tag with dynamic content
                    const style = document.createElement('style');
                    style.textContent = `
                        .${uniqueClass}::after {
                        content: '${contentValue}' !important;
                        }
                    `;
                    document.head.appendChild(style);
                });
                clearInterval(qtyBundlemLTextInterval);
            }
        }, 200);

        var productBundleSectionInterval = setInterval(() => {
            if (window.innerWidth > 990) {
                var bundleLinks = document.querySelectorAll('a[class^="horizontalBundleItems_link_"]');
            } else {
                var bundleLinks = document.querySelectorAll('a[class^="verticalBundleItems_link"]');
            }

            if (bundleLinks.length > 0) {
                const results_products_row = document.querySelector('.results-products .row');
                if (!results_products_row) {
                    console.error('results_products_row not found');
                    return;
                }

                // Clear existing content first
                results_products_row.innerHTML = '';

                // Extract handles array in order
                const handles = Array.from(bundleLinks)
                    .map(linkEl => {
                        let href = linkEl.getAttribute('href');
                        if (!href) return null;
                        return href.replace(/^\/products\//, '').split(/[?#]/)[0];
                    })
                    .filter(Boolean);

                // Fetch all bundleHtmls in parallel and keep order
                Promise.all(handles.map(handle => fetchBundleCardHtml(handle)))
                    .then(allBundleHtmls => {
                        allBundleHtmls.forEach(bundleHtml => {
                            results_products_row.insertAdjacentHTML('beforeend', bundleHtml);
                        });

                        // Reinitialize Trustpilot widgets
                        document.querySelectorAll('.trustpilot-widget').forEach(el => {
                            if (window.Trustpilot && typeof Trustpilot.loadFromElement === 'function') {
                                Trustpilot.loadFromElement(el, true);
                            }
                        });

                        $('[name="bundle-product"]').prop('checked', true);
                        updateTotalPrice();
                        $('.bundle-add-to-cart').removeClass('disabled');
                        $('.results-product-block').show();
                        $('.results-product-section').show();
                        $('.results-product-section .loading__spinner').addClass('hidden');

                    })
                    .catch(err => {
                        console.error('Error fetching bundle-card HTML:', err);
                    });

                clearInterval(productBundleSectionInterval);
            } else {
                setTimeout(() => {
                    if ($('div#rbr-container-element-fbt').length <= 0) {
                        $('.results-product-section').hide();
                        $('.results-product-section .loading__spinner').addClass('hidden');
                        clearInterval(productBundleSectionInterval);
                    }
                }, 3000);
            }
        }, 200);
    }

    $('[name="result-product"]').click(function () {
        var price_total = 0;
        var compareprice_total = 0;
        var currencyMatch;
        var currencySymbol;

        // If no product is selected, reset price
        if ($('[name="result-product"]:checked').length <= 0) {
            $('.results-add-to-cart').addClass('disabled');
            $('.price-value .variant-price').text($('.price-value .variant-price').attr('data-default-price'));

            $('.price-value .variant-compareprice').text($('.price-value .variant-price').attr('data-default-price'));
            $('.price-value .variant-compareprice').addClass('hidden');
            // $('.price-value .variant-compareprice').addClass('hidden');
        } else {
            $('.results-add-to-cart').removeClass('disabled');
            $('[name="result-product"]').each(function () {
                if ($(this).is(':checked')) {
                    // --- PRICE ---
                    var priceText = $(this).attr('data-variant-price');
                    if (priceText) {
                        // Extract currency symbol (from price)
                        currencyMatch = priceText.match(/[^\d.,\s]+/g);
                        currencySymbol = currencyMatch ? currencyMatch[0] : '';

                        // Extract numeric value
                        var match = priceText.match(/[\d.,]+/);
                        if (match) {
                            var raw = match[0];

                            if (raw.includes(',') && raw.includes('.')) {
                                if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) {
                                    raw = raw.replace(/\./g, '').replace(',', '.');
                                } else {
                                    raw = raw.replace(/,/g, '');
                                }
                            } else if (raw.includes(',')) {
                                raw = raw.replace(',', '.');
                            }

                            var number = parseFloat(raw);
                            if (!isNaN(number)) price_total += number;
                        }
                    }

                    // --- COMPARE PRICE ---
                    var comparePriceText = $(this).attr('data-variant-compare-price');
                    if (comparePriceText) {
                        var matchCompare = comparePriceText.match(/[\d.,]+/);
                        if (matchCompare) {
                            var rawCompare = matchCompare[0];

                            if (rawCompare.includes(',') && rawCompare.includes('.')) {
                                if (rawCompare.lastIndexOf(',') > rawCompare.lastIndexOf('.')) {
                                    rawCompare = rawCompare.replace(/\./g, '').replace(',', '.');
                                } else {
                                    rawCompare = rawCompare.replace(/,/g, '');
                                }
                            } else if (rawCompare.includes(',')) {
                                rawCompare = rawCompare.replace(',', '.');
                            }

                            var compareNumber = parseFloat(rawCompare);
                            if (!isNaN(compareNumber)) compareprice_total += compareNumber;
                        }
                    }
                }
            });

            // Update displayed price and compare price
            $('.price-value .variant-price').text(currencySymbol + price_total.toFixed(2));

            if (compareprice_total > 0) {
                $('.price-value .variant-compareprice').text(currencySymbol + compareprice_total.toFixed(2));
                $('.price-value .variant-compareprice').removeClass('hidden');
            } else {
                $('.price-value .variant-compareprice').addClass('hidden');
            }
        }
    });

    $('.results-add-to-cart').on('click', function (e) {
        e.preventDefault();

        var itemsArray = [];

        $('[name="result-product"]:checked').each(function (index, item) {
            itemsArray.push({
                id: parseInt($(item).val()),
                quantity: 1
            });
        });

        $(this).addClass('disabled').addClass('adding-to-cart');
        $(this).find('.loading__spinner').removeClass('hidden');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: itemsArray
            })
        })
            .then(res => res.json())
            .then(res => {
                fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
                    .then((response) => response.json())
                    .then((sections) => {
                        const sectionIds = ['cart-drawer'];
                        for (const sectionId of sectionIds) {
                            const htmlString = sections[sectionId];
                            const html = new DOMParser().parseFromString(htmlString, 'text/html');
                            const sourceElement = html.querySelector(`${sectionId}`);
                            const targetElement = document.querySelector(`${sectionId}`);
                            if (targetElement && sourceElement) {
                                targetElement.replaceWith(sourceElement);
                            }
                        }

                        // Replace cart icon bubble content
                        const cartIconHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                        const newBubble = cartIconHTML.querySelector('.cart-count-bubble');
                        const oldBubble = document.querySelector('.cart-count-bubble');
                        if (newBubble && oldBubble) {
                            oldBubble.replaceWith(newBubble);
                        }

                        updateProgressBar();
                        loadCartDrawerProducts();
                        document.body.classList.add('overflow-hidden');
                        const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                        if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
                        theme_cart.classList.add('active');
                        $('[name="result-product"]:checked').trigger('click');
                    })
                    .catch((e) => {
                        console.error('Error updating cart sections:', e);
                    });

                $(this).removeClass('disabled').removeClass('adding-to-cart');
                $(this).find('.loading__spinner').addClass('hidden');
            })
            .catch(error => {
                console.error('Add to cart error:', error);
                $(this).removeClass('disabled').removeClass('adding-to-cart');
                $(this).find('.loading__spinner').addClass('hidden');
            });

    });

    const stickyBar = document.querySelector('.sticky-atc-bar');

    // function isOnScreen(element) {
    //     if (!element.length) return false;
    //     const rect = element[0].getBoundingClientRect();
    //     return (
    //         rect.top < window.innerHeight &&
    //         rect.bottom > 0
    //     );
    // }

    // // Initial check on load
    // if (isOnScreen($(".main-product"))) {
    //     $(".sticky-atc-barn").fadeOut(100);
    // } else {
    //     $(".sticky-atc-barn").fadeIn(100);
    // }

    // // On scroll
    // $(window).on('scroll', function () {
    //     if (isOnScreen($("#custom-product"))) {
    //         $(".sticky-atc-bar").fadeOut(10);
    //     } else {
    //         $(".sticky-atc-bar").fadeIn(10);
    //     }
    // });

    if (stickyBar) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 1500) {
                stickyBar.classList.remove('hidden');
            } else {
                stickyBar.classList.add('hidden');
            }
        });

        const toggle = document.getElementById('variantToggle');
        const dropdown = document.getElementById('variantDropdown');
        const selectedText = document.getElementById('selectedVariantText');
        const addToCartBtn = document.querySelector('.stickyAddToCart');

        // Toggle dropdown
        toggle.addEventListener('click', () => {
            dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
        });

        // Click outside to close
        document.addEventListener('click', (e) => {
            if (!toggle.contains(e.target) && !dropdown.contains(e.target)) {
                dropdown.style.display = 'none';
            }
        });

        // Update selected variant
        document.querySelectorAll('.variant-option').forEach(option => {
            option.addEventListener('click', () => {
                const price = option.dataset.price;
                const qty_text_custom = option.querySelector('.qty-text-custom').innerText;
                const price_text = option.querySelector('.price-text').innerText;
                selectedText.querySelector('.qty-text-custom').innerText = qty_text_custom;
                selectedText.querySelector('.price-text').innerText = price_text;
                option.querySelector('input').checked = true;
                dropdown.style.display = 'none';
            });
        });

        function getIndex($el) {
            return $el.index();
        }

        /* When discount option is clicked */
        $(document).on('click', '#rbr-container-element-volume [data-rbrselector="discountOptionV5"]', function () {
            const index = getIndex($(this));
            console.log('index', index)

            const $variant = $('.sticky-atc-bar .variant-option').eq(index);
            console.log('$variant', $variant)

            if ($variant.length && !$variant.is(this)) {
                $variant.trigger('click');
            }
        });

        // Add to cart
        if (addToCartBtn) {
            addToCartBtn.addEventListener('click', () => {
                const selected = document.querySelector('.variant-option input:checked');
                if (!selected) return alert("Seleziona una variante.");

                const variantId = selected.closest('.variant-option').dataset.id;
                const qty = selected.dataset.qty;

                document.querySelector('.sticky-atc-content .loading__spinner').classList.remove('hidden');
                document.querySelector('.sticky-atc-content .stickyAddToCart span').style.opacity = 0;
                document.querySelector('.sticky-atc-content .stickyAddToCart img').style.opacity = 0;

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: qty })
                }).then(res => {
                    fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
                        .then((response) => response.json())
                        .then((sections) => {
                            const sectionIds = ['cart-drawer'];
                            for (const sectionId of sectionIds) {
                                const htmlString = sections[sectionId];
                                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                                const sourceElement = html.querySelector(`${sectionId}`);
                                const targetElement = document.querySelector(`${sectionId}`);
                                if (targetElement && sourceElement) {
                                    targetElement.replaceWith(sourceElement);
                                }
                            }

                            // Replace cart icon bubble content
                            const cartIconHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                            const newBubble = cartIconHTML.querySelector('.cart-count-bubble');
                            const oldBubble = document.querySelector('.cart-count-bubble');
                            if (newBubble && oldBubble) {
                                oldBubble.replaceWith(newBubble);
                            }

                            updateProgressBar();
                            loadCartDrawerProducts();
                            document.body.classList.add('overflow-hidden');
                            const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                            if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
                            theme_cart.classList.add('active');
                            if (res.ok) {
                                // optional success message
                                // alert('Aggiunto al carrello!');
                            }

                            document.querySelector('.sticky-atc-content .stickyAddToCart span').style.opacity = 1;
                            document.querySelector('.sticky-atc-content .stickyAddToCart img').style.opacity = 1;
                            document.querySelector('.sticky-atc-content .loading__spinner').classList.add('hidden');
                        });
                });
            });
        }
    }

    document.querySelector('.variant-option input:checked')?.click();

    if (typeof gsap !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.matchMedia({
            "(min-width: 768px)": function () {
                const process = document.querySelector('.process');
                const heading = document.querySelector('.driveus-heading');

                if (process && heading) {
                    // Pin heading
                    ScrollTrigger.create({
                        trigger: heading,
                        start: "center top",
                        end: () => "+=" + process.offsetWidth,
                        pin: true,
                        pinSpacing: false
                    });

                    // Horizontal scroll for sections
                    let sections = gsap.utils.toArray('.process__item');
                    gsap.to(sections, {
                        xPercent: -100 * (sections.length - 1),
                        ease: "none",
                        scrollTrigger: {
                            trigger: process,
                            start: "center center",
                            end: () => "+=" + process.offsetWidth,
                            scrub: 1,
                            pin: true,
                            snap: 1 / (sections.length - 1),
                            anticipatePin: 1
                        }
                    });
                }
            },
            "(max-width: 767px)": function () {
                // Do nothing or reset any GSAP if needed
                ScrollTrigger.getAll().forEach(st => st.kill());
            }
        });

        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.matchMedia({
            "(min-width: 768px)": function () {
                var anim = gsap.fromTo(".leaf1",
                    { x: "-30%", y: "-15%", scale: 1 },

                    {
                        x: "10%", y: "10%", scale: 1.2,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: ".section",
                            start: "top top",
                            end: "center top",
                            scrub: 1
                        }
                    });

                var anim = gsap.fromTo(".leaf2",
                    { x: "45%", y: "20%", scale: 1 },

                    {
                        x: "-10%", y: "10%", scale: 1.2,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: ".section",
                            start: "top top",
                            end: "center top",
                            scrub: 1
                        }
                    });

                return () => anim.kill();
            }
        });
        gsap.utils.toArray(".we-believe-section .row .col-12").forEach((col) => {
            gsap.to(col, {
                y: 0,
                opacity: 1,                 // optional: fade container too
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: col,
                    start: "top 80%",
                    toggleActions: "play none none reverse"
                }
            });

            gsap.to(col.querySelectorAll(".we-believe-txt"), {
                color: "rgba(242,244,245,1)", // fully opaque
                duration: 1.3,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: col,
                    start: "center 80%",
                    toggleActions: "play none none reverse"
                }
            });
        });

    }

    function wrapWords(node) {
        node.childNodes.forEach(child => {
            if (child.nodeType === Node.TEXT_NODE) {
                const text = child.textContent;
                if (!text.trim()) return;

                const frag = document.createDocumentFragment();
                text.split(/\s+/).forEach((word, i, arr) => {
                    const span = document.createElement('span');
                    span.textContent = word;
                    frag.appendChild(span);
                    if (i < arr.length - 1) frag.appendChild(document.createTextNode(' '));
                });
                child.replaceWith(frag);
            } else {
                wrapWords(child);
            }
        });
    }

    function animateWords() {
        gsap.registerPlugin(ScrollTrigger);
        gsap.set('.who-are-content span', { color: '#313131' });
        gsap.to('.who-are-content span', {
            color: '#F2F4F5',
            stagger: 0.1,
            scrollTrigger: {
                trigger: '.who-are-content',
                start: 'top 70%',
                end: 'bottom 50%',
                scrub: true,
                invalidateOnRefresh: true
            }
        });

        window.addEventListener('load', () => ScrollTrigger.refresh());
    }

    function init() {
        const container = document.querySelector('.who-are-content h3');
        if (!container) {
            requestAnimationFrame(init);
            return;
        }
        wrapWords(container);
        animateWords();
    }

    init();


    $('.owl-carousel.logo-carousel').owlCarousel({
        margin: 80,
        loop: true,
        autoWidth: true,
        dots: false,
        mouseDrag: false,
        autoplay: true,
        items: 6,
        autoplayTimeout: 2000,
        center: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                margin: 40
            },
            768: {
                margin: 60
            },
            1200: {
                margin: 80
            }
        }
    })

    $('.owl-carousel.products-carousel').owlCarousel({
        margin: 16,
        loop: false,
        dots: false,
        items: 3,
        responsive: {
            0: {
                items: 1,
                stagePadding: 10
            },
            576: {
                items: 2,
                stagePadding: 10
            },
            1200: {
                items: 3,
                stagePadding: 0
            }
        }
    })

    $('.owl-carousel.featured-products-carousel').owlCarousel({
        margin: 16,
        loop: false,
        dots: true,
        nav: true,
        items: 3,
        responsive: {
            0: {
                items: 1,
                nav: false
            },
            576: {
                items: 2,
                nav: false
            },
            1200: {
                items: 3,
                nav: true
            }
        }
    })

    var related_products_interval = setInterval(() => {
        if ($('.owl-carousel.related-products-carousel').length > 0) {
            $('.owl-carousel.related-products-carousel').owlCarousel({
                margin: 16,
                loop: false,
                dots: true,
                nav: true,
                items: 3,
                responsive: {
                    0: {
                        items: 1,
                        nav: false
                    },
                    576: {
                        items: 2,
                        nav: false
                    },
                    1200: {
                        items: 3,
                        nav: true
                    }
                }
            })
            clearInterval(related_products_interval);
        }
    }, 300);

    $('.owl-carousel.featured-products-carousel.featured-products-carousel-arrows').owlCarousel({
        margin: 16,
        loop: false,
        dots: true,
        nav: true,
        items: 3,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            576: {
                items: 2,
                nav: true
            },
            1200: {
                items: 3,
                nav: true
            }
        }
    })



    $('.owl-carousel.testimonials-carousel').owlCarousel({
        margin: 30,
        loop: false,
        dots: false,
        nav: false,
        items: 1,
        stagePadding: 150,
        responsive: {
            0: {
                stagePadding: 10,
                items: 1,
                margin: 20,
                dots: true,
            },
            768: {
                stagePadding: 0,
                items: 2,
                margin: 20,
            },
            992: {
                stagePadding: 0,
                items: 2,
                margin: 20,
            },
            1200: {
                stagePadding: 150,
                items: 1,
                margin: 30
            }
        }
    })

    $('.owl-carousel.blog-carousel').owlCarousel({
        margin: 16,
        dots: false,
        items: 3,
        stagePadding: 10,
        responsive: {
            0: {
                items: 1,
                stagePadding: 10,
                dots: true
            },
            576: {
                items: 2,
                stagePadding: 10,
                dots: true
            },
            992: {
                items: 3,
                stagePadding: 0
            },
            1200: {
                items: 3,
                stagePadding: 0
            }
        }
    })

    $('.owl-carousel.natural-ingredient-carousel').owlCarousel({
        margin: 16,
        loop: false,
        dots: true,
        nav: true,
        items: 3,
        stagePadding: 0,
        responsive: {
            0: {
                items: 1,
                nav: false,
                stagePadding: 10,
            },
            576: {
                items: 2,
                nav: false,
                stagePadding: 0
            },
            1200: {
                items: 3,
                nav: true,
                stagePadding: 0
            }
        }
    })
    loadCartDrawerProducts();
    updateProductCarausals();

    var $slider = $(".tab-slider");
    function toggleOwl() {
        var winWidth = $(window).width();
        if (winWidth >= 768 && winWidth <= 991) {
            if (!$slider.hasClass("owl-loaded")) {
                $slider.addClass("owl-carousel").owlCarousel({
                    loop: false,
                    margin: 10,
                    dots: true,
                    items: 1,
                    stagePadding: 100
                });
            }
        } else {
            if ($slider.hasClass("owl-loaded")) {
                $slider.trigger("destroy.owl.carousel").removeClass("owl-carousel owl-loaded");
                $slider.find(".owl-stage-outer").children().unwrap();
            }
        }
    }

    toggleOwl();
    $(window).resize(function () {
        toggleOwl();
    });


    $('.sub-menu > li > a').hover(function () {
        if ($(this).attr('data-img-src')) {
            $(this)
                .parents('.mega-menu')
                .find('.mega-menu-img img')
                .attr('style', 'max-height:' + $('.mega-menu .row').height() + 'px');

            $(this)
                .parents('.mega-menu')
                .find('.mega-menu-img img')
                .attr('src', $(this).attr('data-img-src'));

            if ($(this).attr('data-btn-text') && $(this).attr('data-btn-url')) {
                $(this)
                    .parents('.mega-menu')
                    .find('.mega-menu-img .button')
                    .text($(this).attr('data-btn-text'))
                    .attr('href', $(this).attr('data-btn-url'));

                $(this).parents('.mega-menu').find('.mega-menu-img .button').show();
            } else {
                $(this).parents('.mega-menu').find('.mega-menu-img .button').hide();
            }

            $(this).parents('.mega-menu').find('.mega-menu-img').show();
            $(this).parents('.mega-menu').find('.mega-menu-products-wrapper').hide();
        } else {
            $(this).parents('.mega-menu').find('.mega-menu-img').hide();
            $(this).parents('.mega-menu').find('.mega-menu-img img').removeAttr('style');
            $(this).parents('.mega-menu').find('.mega-menu-img .button').hide();
            $(this).parents('.mega-menu').find('.mega-menu-products-wrapper').hide();

            var mega_menu_products_wrapper = $(this).parents('.mega-menu').find('.mega-menu-products-wrapper');
            if ($(this).attr('data-menu-product-1-title')) {
                if ($(this).attr('data-menu-product-1-img-1')) {
                    mega_menu_products_wrapper.find('.mega-menu-product-1-img').find('img').attr('src', $(this).attr('data-menu-product-1-img-1'));
                    mega_menu_products_wrapper.find('.mega-menu-product-1-img').show();
                } else {
                    mega_menu_products_wrapper.find('.mega-menu-product-1-img').hide();
                }
                mega_menu_products_wrapper.find('.mega-menu-product-1-title').html($(this).attr('data-menu-product-1-title'));
                mega_menu_products_wrapper.find('a').attr('href', $(this).attr('data-menu-product-1-url'));
                mega_menu_products_wrapper.find('.mega-menu-product-1-price').html($(this).attr('data-menu-product-1-price'));
                if ($(this).attr('data-menu-product-1-compareprice') != undefined) {
                    mega_menu_products_wrapper.find('.mega-menu-product-1-compareprice').html($(this).attr('data-menu-product-1-compareprice'));
                } else {
                    mega_menu_products_wrapper.find('.mega-menu-product-1-compareprice').html('');
                }
                $(this).parents('.mega-menu').find('.mega-menu-products-wrapper').show();
            } else {
                mega_menu_products_wrapper.find('.mega-menu-product-1-img').hide();
            }
            if ($(this).attr('data-menu-product-2-title')) {
                if ($(this).attr('data-menu-product-2-img-1')) {
                    mega_menu_products_wrapper.find('.mega-menu-product-2-img').find('img').attr('src', $(this).attr('data-menu-product-2-img-1'));
                    mega_menu_products_wrapper.find('.mega-menu-product-2-img').show();
                } else {
                    mega_menu_products_wrapper.find('.mega-menu-product-2-img').hide();
                }
                mega_menu_products_wrapper.find('.mega-menu-product-2-title').html($(this).attr('data-menu-product-2-title'));
                mega_menu_products_wrapper.find('a').attr('href', $(this).attr('data-menu-product-2-url'));
                mega_menu_products_wrapper.find('.mega-menu-product-2-price').html($(this).attr('data-menu-product-2-price'));
                if ($(this).attr('data-menu-product-2-compareprice') != undefined) {
                    mega_menu_products_wrapper.find('.mega-menu-product-2-compareprice').html($(this).attr('data-menu-product-2-compareprice'));
                } else {
                    mega_menu_products_wrapper.find('.mega-menu-product-2-compareprice').html('');
                }
                $(this).parents('.mega-menu').find('.mega-menu-products-wrapper').show();
            } else {
                mega_menu_products_wrapper.find('.mega-menu-product-2-img').hide();
            }
        }
    });

    if (window.innerWidth > 767) {
        const navSlider = new Swiper('.nav-slider', {
            direction: 'vertical',
            slidesPerView: 5,
            spaceBetween: 0,
            watchSlidesProgress: false,
            slideToClickedSlide: false,
            centeredSlides: false,
            breakpoints: {
                0: { direction: 'horizontal' },
                992: { direction: 'vertical' }
            }
        });

        const mainSlider = new Swiper('.main-slider', {
            direction: 'vertical',
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            mousewheel: {
                forceToAxis: true,  // makes scrolling more controlled
                sensitivity: 0.5,   // reduce sensitivity (default 1)
                releaseOnEdges: true,
            },
            loop: false,
            thumbs: {
                swiper: navSlider
            },
            breakpoints: {
                0: { direction: 'horizontal' },   // mobile/tab
                992: { direction: 'vertical' }    // desktop
            }
        });

        // Fade out text and image on slide change start
        mainSlider.on('slideChangeTransitionStart', () => {
            document.querySelectorAll('.fade-content').forEach(el => {
                el.style.opacity = 0;
                el.style.transform = 'translateY(50px)';
            });
            document.querySelectorAll('.fade-image').forEach(el => {
                el.style.opacity = 0;
                el.style.transform = 'translateY(50px)';
            });
        });

        // Fade in active slide text and image on slide change end
        mainSlider.on('slideChangeTransitionEnd', () => {
            const activeText = document.querySelector('.swiper-slide-active .fade-content');
            const activeImage = document.querySelector('.swiper-slide-active .fade-image');
            if (activeText) {
                activeText.style.opacity = 1;
                activeText.style.transform = 'translateY(0)';
            }
            if (activeImage) {
                activeImage.style.opacity = 1;
                activeImage.style.transform = 'translateY(0)';
            }
        });

        // Trigger fade for first slide on load
        //  window.addEventListener('load', () => {
        //     const firstText = document.querySelector('.swiper-slide-active .fade-content'); 
        //     if (firstText) {
        //     firstText.style.opacity = 1;
        //     firstText.style.transform = 'translateY(0)';
        //     }

        //     if (firstImage) {
        //     firstImage.style.opacity = 1;
        //     firstImage.style.transform = 'translateY(0)';
        //     }
        // });
    }



    document.querySelectorAll("product-form").forEach(function (form) {
        const variantId = form.closest("[data-variant-id]")?.dataset.variantId;
        const sectionId = form.closest("[data-section-id]")?.dataset.sectionId;

        if (!variantId || !sectionId) return;

        const key = `quick_added_${variantId}`;

        // Get carted products array from sessionStorage for that section
        let cartedProducts = JSON.parse(sessionStorage.getItem(key)) || [];

        // If variantId is in stored array, add class to form
        if (cartedProducts.includes(variantId)) {
            form.closest('.quick-cart').classList.add("added-to-cart");
            form.closest('.quick-cart').querySelector('.addtocart-icon').classList.add('hidden');
            form.closest('.quick-cart').querySelector('.success-added').classList.remove('hidden');
        }
    });

    $('.scroll-to-products').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#main-collection-filters').offset().top
        }, 'medium'); // 600ms = scroll duration
    });

    $('.certitication-btn').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.certification-faq').offset().top
        }, 'medium'); // 600ms = scroll duration
    });

    $('li.language-icon').click(function (e) {
        if (!$(e.target).closest('.desktop-localization-wrapper').length)
            $('.desktop-localization-wrapper').toggleClass('active');
    });


    // const form = document.querySelector('#newsletter-form-blog'); // adjust ID as needed
    // const emailInput = form.querySelector('input[name="contact[email]"]');

    // form.addEventListener('submit', function (e) {
    //   const email = emailInput.value.trim();
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // //   form.querySelector('.email-validate').classList.add('hidden');

    //   if (!emailRegex.test(email)) {
    //     e.preventDefault(); // Stop form from submitting
    //     // form.querySelector('.email-validate').classList.remove('hidden');
    //     form.querySelector('button').classList.add('disabled');
    //     emailInput.focus();
    //   }
    // });

    const form = document.getElementById('newsletter-form-blog');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form) {
        const emailInput = form.querySelector('[type="email"]');
        const submitButton = form.querySelector('button');

        // Function to toggle button state
        function validateEmailInput() {
            const email = emailInput.value.trim();
            const isValid = emailRegex.test(email);

            if (!isValid) {
                submitButton.classList.add('disabled');
                submitButton.setAttribute('disabled', 'disabled');
            } else {
                submitButton.classList.remove('disabled');
                submitButton.removeAttribute('disabled');
            }
        }

        // Run validation on input events
        // emailInput.addEventListener('input', validateEmailInput);

        // Initial state check (in case there's a saved value)
        // validateEmailInput();
    }

    const form_footer = document.getElementById('newsletter-form-footer');
    const emailInput_footer = form_footer.querySelector('[type="email"]');
    const submitButton_footer = form_footer.querySelector('button');

    // Function to toggle button state
    function validateemailInput_footer() {
        const email = emailInput_footer.value.trim();
        const isValid_footer = emailRegex.test(email);

        if (!isValid_footer) {
            submitButton_footer.classList.add('disabled');
            submitButton_footer.setAttribute('disabled', 'disabled');
        } else {
            submitButton_footer.classList.remove('disabled');
            submitButton_footer.removeAttribute('disabled');
        }
    }

    // Run validation on input events
    // emailInput_footer.addEventListener('input', validateemailInput_footer);

    // Initial state check (in case there's a saved value)
    // validateemailInput_footer();

    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    document.querySelector('#newsletter-form-blog')?.classList.remove('active-form-blog');
    document.querySelector('#newsletter-form-footer').classList.remove('active-form-footer');

    const posted = urlParams.get('customer_posted') === 'true';
    const posted_contact = urlParams.get('contact_posted') === 'true';

    if (posted && hash === '#newsletter-form-blog') {
        const form = document.getElementById('newsletter-form-blog');
        if (form) {
            form.classList.add('active-form-blog');
        }
    }

    if (posted && hash === '#newsletter-form-footer') {
        const form = document.getElementById('newsletter-form-footer');
        if (form) {
            form.classList.add('active-form-footer');
        }
    }

    $('.contact-form-submit').on('click', function (e) {
        // e.preventDefault();
        let isValid = true;

        // Clear previous error messages
        $('.form-group p.error-message').remove();
        $('.form-group').removeClass('error-msg');

        // Regex for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check required text inputs and textarea
        $('#ContactForm input.required[type="email"], #ContactForm input.required[type="text"], #ContactForm textarea.required').each(function () {
            const val = $(this).val().trim();
            const name = $(this).attr('name');

            if (val === '') {
                isValid = false;
                if ($(this).siblings('p.error-message').length === 0) {
                    $(this).after('<p class="error-message" style="color:#E3351D; font-size:14px; margin-top:5px;">Campo obbligatorio</p>');
                    $(this).parents('.form-group').addClass('error-msg');
                }
            } else if (name === 'contact[email]' && !emailRegex.test(val)) {
                // Check for valid email format
                isValid = false;
                if ($(this).siblings('p.error-message').length === 0) {
                    $(this).after('<p class="error-message" style="color:#E3351D; font-size:14px; margin-top:5px;">Inserisci un indirizzo email valido</p>');
                    $(this).parents('.form-group').addClass('error-msg');
                }
            }
        });

        // Check checkbox separately
        let checkbox = $('#agree.required');
        if (!checkbox.is(':checked')) {
            isValid = false;
            if (checkbox.siblings('p.error-message').length === 0) {
                // checkbox.after('<p class="error-message" style="color:#E3351D; font-size:14px; margin-top:5px;">Campo obbligatorio</p>');
                checkbox.parents('.form-group').addClass('error-msg');
            }
        }

        // Prevent form submission if invalid
        if (isValid) {
            //  $('#thankYouModal').fadeIn();
            // $(this).parents('form').submit();
            // $(this).parents('form').click();
            return true;
        } else {
            return false;
        }
    });

    if (posted_contact && hash === '#ContactForm') {
        $('#thankYouModal').fadeIn();
        $('body').addClass('overflow-hidden');
    }
    $('#closeModalBtn, #confirmCloseBtn').on('click', function () {
        $('#thankYouModal').fadeOut();
        window.history.replaceState({}, document.title, window.location.href.replace('&contact_posted=true#ContactForm', '').replace('?contact_posted=true#ContactForm', ''));
        $('body').removeClass('overflow-hidden');
    });

    const $searchInput = $('input[name="faq-search"]');
    const $faqSections = $('.faq-link-content-inner');
    const $faqSectionsAccordionitem = $('.faq-link-content-inner .accordion-item');
    const $noDataMessage = $('.no-data-found');
    const $menuLinks = $('.faq-links a');

    function normalizeText(text) {
        return $.trim(text).toLowerCase();
    }

    function updateLeftMenuVisibility() {
        $menuLinks.each(function () {
            const targetId = $(this).attr('href').replace('#', '');
            const $targetSection = $('#' + targetId);

            if ($targetSection.is(':visible')) {
                $(this).closest('li').show();
            } else {
                $(this).closest('li').hide();
            }
        });
    }

    $searchInput.on('input', function () {
        const searchText = normalizeText($(this).val());
        let anyMatchFound = false;

        if (searchText === '') {
            $faqSections.show();
            $('.faq-glossary-content').show();
            $menuLinks.closest('li').show(); // show all menu items
            $noDataMessage.hide();
            $faqSectionsAccordionitem.show();
            return;
        }

        $faqSections.each(function () {
            const $section = $(this);
            let sectionMatched = false;
            let anyItemMatched = false;

            // 🔍 Check accordion items within the section
            $section.find('.accordion-item').each(function () {
                const title = normalizeText($(this).find('.accordion-title').text());
                const content = normalizeText($(this).find('.accordion-content').text());
                if (title.includes(searchText) || content.includes(searchText)) {
                    $(this).show(); // Show matching item
                    anyItemMatched = true;
                } else {
                    $(this).hide(); // Hide non-matching item
                }
            });

            // 🔍 Also check section title and button text
            const labelTxt = normalizeText($section.find('.label-txt').text());
            const actionLinkTxt = normalizeText($section.find('.action-link a').text());
            if (labelTxt.includes(searchText) || actionLinkTxt.includes(searchText)) {
                sectionMatched = true;
            }

            // Show or hide the entire section based on item matches
            if (anyItemMatched || sectionMatched) {
                $section.show();
                anyMatchFound = true;
            } else {
                $section.hide();
            }
        });

        // Highlight the first visible menu item
        $('.faq-links li:visible:first-child a').addClass('active');

        if (!anyMatchFound) {
            $noDataMessage.show();
            $('.faq-glossary-content').hide();
        } else {
            $noDataMessage.hide();
            $('.faq-glossary-content').show();
        }

        updateLeftMenuVisibility(); // 🔁 Update menu links

        $(window).scroll();

        $(window).on("scroll", function () {
            let current = "";
            $('.faq-link-content .faq-link-content-inner:visible').each(function () {
                const sectionTop = $(this).offset().top - 120;
                if ($(window).scrollTop() >= sectionTop) {
                    current = $(this).attr("id");
                }
            });

            $('.faq-links a').removeClass("active");

            if (current) {
                var activeLink = $('.faq-links li a[href="#' + current + '"]');
                activeLink.addClass("active");

                const parentLink = activeLink.closest("ul").parent("li").children("a");
                parentLink.addClass("active");
            }

            if ($('.faq-links li a.active').length <= 0) {
                // $('.faq-links > li:first-child a').addClass('active');
                // $('.faq-links > li a').removeClass('active');
                $('.faq-links > li:visible:eq(0) a').addClass('active');
            }
        });

    });


    // Optional: trigger search on icon click
    $('.faq-search-form .action-btn').on('click', function (e) {
        e.preventDefault();
        $searchInput.trigger('input');
    });

    if ($('#FacetsWrapperDesktop > fieldset').length > 1)
        $('#FacetsWrapperDesktop > fieldset:eq(0)').addClass('hidden');

    // const klaviyoLists = {
    //     de: 'Rnns4L',  // German list
    //     fr: 'V4jXu2',  // French list
    //     it: 'RcZbnw'   // Italian list
    // };

    // // Function to get Shopify language
    // function getShopifyLanguage() {
    //     // Method 1: Check if Shopify.locale exists (most reliable)
    //     if (typeof Shopify !== 'undefined' && Shopify.locale) {
    //         return Shopify.locale.toLowerCase();
    //     }

    //     // Method 2: Check document lang attribute
    //     const docLang = document.documentElement.lang;
    //     if (docLang) {
    //         return docLang.toLowerCase().split('-')[0]; // Get just the language part (e.g., 'de' from 'de-DE')
    //     }

    //     // Method 3: Check HTML lang attribute
    //     const htmlLang = document.querySelector('html').getAttribute('lang');
    //     if (htmlLang) {
    //         return htmlLang.toLowerCase().split('-')[0];
    //     }

    //     // Method 4: Check URL for language indicators
    //     const path = window.location.pathname;
    //     if (path.includes('/de/') || path.includes('/de-')) return 'de';
    //     if (path.includes('/fr/') || path.includes('/fr-')) return 'fr';
    //     if (path.includes('/it/') || path.includes('/it-')) return 'it';

    //     // Method 5: Check subdomain
    //     const subdomain = window.location.hostname.split('.')[0];
    //     if (subdomain === 'de') return 'de';
    //     if (subdomain === 'fr') return 'fr';
    //     if (subdomain === 'it') return 'it';

    //     // Method 6: Check browser language as fallback
    //     const browserLang = navigator.language.toLowerCase().split('-')[0];
    //     if (['de', 'fr', 'it'].includes(browserLang)) {
    //         return browserLang;
    //     }

    //     // Default fallback
    //     return 'it';
    // }

    // // Function to map language to list ID
    // function getListIdFromLanguage(language) {
    //     const langKey = language.toLowerCase();

    //     // Direct mapping
    //     if (klaviyoLists[langKey]) {
    //         return klaviyoLists[langKey];
    //     }

    //     // Handle language variants
    //     if (langKey.startsWith('de')) return klaviyoLists.de;
    //     if (langKey.startsWith('fr')) return klaviyoLists.fr;
    //     if (langKey.startsWith('it')) return klaviyoLists.it;

    //     // Default to Italian
    //     return klaviyoLists.it;
    // }

    // // Newsletter form handler
    // document.addEventListener('DOMContentLoaded', function() {
    //     const form = document.getElementById('newsletter-form-footer');

    //     if (form) {
    //         form.addEventListener('submit', function (e) {
    //             e.preventDefault();
    //             e.stopPropagation();

    //             console.log('innn');
    //             return false;

    //             const emailInput = this.querySelector('input[name="contact[email]"]');
    //             const submitButton = this.querySelector('button[type="submit"]');

    //             if (!emailInput || !submitButton) {
    //                 console.error('Newsletter form elements not found');
    //                 return;
    //             }

    //             const email = emailInput.value.trim();

    //             // Basic email validation
    //             if (!email || !email.includes('@')) {
    //                 alert('Please enter a valid email address');
    //                 return;
    //             }

    //             // Get current language and corresponding list ID
    //             const currentLanguage = getShopifyLanguage();
    //             const listId = getListIdFromLanguage(currentLanguage);

    //             console.log('Detected language:', currentLanguage);
    //             console.log('Using list ID:', listId);

    //             // Disable submit button during request
    //             const originalButtonHTML = submitButton.innerHTML;
    //             submitButton.disabled = true;
    //             submitButton.innerHTML = 'Subscribing...';

    //             try {
    //                 const response = fetch('/subscribe.php', {
    //                     method: 'POST',
    //                     headers: { 
    //                         'Content-Type': 'application/json',
    //                         'Accept': 'application/json'
    //                     },
    //                     body: JSON.stringify({ 
    //                         email: email, 
    //                         listId: listId 
    //                     })
    //                 });

    //                 const result = response.json();

    //                 if (result.success) {
    //                     // Success handling
    //                     alert('Successfully subscribed to newsletter!');
    //                     emailInput.value = ''; // Clear the form
    //                 } else {
    //                     // Error handling
    //                     console.error('Subscription error:', result.error);
    //                     alert(result.error || 'Subscription failed. Please try again.');
    //                 }

    //             } catch (err) {
    //                 console.error('Network error:', err);
    //                 alert('Connection error. Please check your internet connection and try again.');
    //             } finally {
    //                 // Re-enable submit button
    //                 submitButton.disabled = false;
    //                 submitButton.innerHTML = originalButtonHTML;
    //             }
    //         });
    //     } else {
    //         console.error('Newsletter form not found');
    //     }
    // });

    document.querySelector('.footer-newsletter-button').addEventListener('click', function (e) {
        e.preventDefault();
        const button = this;
        const email_newsletter_lsit = document.querySelector('#newsletter-form-footer [name="contact[email]"]').value;
        const errorMessage = document.querySelector('.newsletter-form__message--error');
        const errorMessageEle = document.querySelector('.newsletter-form__message--error .error-msg');
        const emailBlankMessage = errorMessage.dataset.emailBlank;
        const emailInvalidMessage = errorMessage.dataset.emailInvalid;

        // Disable button immediately
        button.disabled = true;

        // Helper functions
        function showError(message) {
            errorMessageEle.textContent = message;
            errorMessage.style.display = 'flex';
            button.disabled = false;
        }

        function hideError() {
            errorMessage.style.display = 'none';
            errorMessageEle.textContent = '';
        }

        hideError();

        // Blank email
        if (email_newsletter_lsit === '') {
            showError(emailBlankMessage);
            return;
        }

        // Invalid email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email_newsletter_lsit)) {
            showError(emailInvalidMessage);
            return;
        }
        
        const pageLanguage = Shopify.locale; // 'de', 'fr', 'it'
        const klaviyoLists = {
            de: 'Rnns4L',
            fr: 'V4jXu2',
            it: 'RcZbnw'
        };

        var targetListId = klaviyoLists[pageLanguage];
        if (targetListId == undefined || targetListId == '')
            targetListId = 'RcZbnw';

        // fetch(`https://a.klaviyo.com/api/v2/list/${targetListId}/subscribe`, {
        // method: 'POST',
        // headers: { 'Content-Type': 'application/json' },
        // body: JSON.stringify({
        //     api_key: 'Tp3F5u',
        //     email: email_newsletter_lsit
        // })
        // })
        // .then(res => res.json())
        // .then(data => console.log('Subscribed:', data))
        // .catch(err => console.error(err));

        const response = fetch('https://practicals.equest.solutions/Eusphera/subscribe.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                email: email_newsletter_lsit,
                listId: targetListId
            })
        })
            .then(res => res.json())
            .then(data => {
                var success_redirect = '?customer_posted=true#newsletter-form-footer';
                if (data.success) {
                    // Redirect after successful subscription
                    // window.location.href = window.location.pathname + success_redirect;                
                    document.querySelector('.newsletter-form__message--success').style.display = 'block';
                    document.querySelector('#newsletter-form-footer [name="contact[email]"]').value = '';
                    setTimeout(() => {
                        document.querySelector('.newsletter-form__message--success').style.display = 'none';
                        button.disabled = false;
                    }, 4000);
                } else if (!data.success) {
                    alert(data.error); // optional: show error
                }
            })
            .catch(err => console.error(err));

        //     var form = document.getElementById('newsletter-form-footer');
        //     // const email = form.querySelector('#email').value;
        //     const email = document.getElementById('email')
        //     const listId_it = 'RcZbnw'; // Replace with your actual list ID
        //     const publicApiKey = 'Tp3F5u'; // Replace with your public API key

        //     // return false;

        //     fetch(`https://a.klaviyo.com/api/v2/list/${listId_it}/subscribe?api_key=${publicApiKey}`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({
        //         profiles: [{ email: email }]
        //     })
        //     })
        //     .then(response => {
        //     if (response.ok) {
        //         document.querySelector('.newsletter-form__message--success').innerText = 'Thanks for subscribing!';
        //         document.getElementById('newsletter-form-footer').reset();
        //     } else {
        //         return response.json().then(err => {
        //         console.error(err);
        //         throw new Error('Subscription failed');
        //         });
        //     }
        //     })
        //     .catch(error => {
        //     document.querySelector('.newsletter-form__message--error').innerText = 'There was an error. Please try again.';
        //     });
    });

    document.querySelector('.blog-newsletter-button')?.addEventListener('click', function (e) {
        e.preventDefault();
        const button = this;
        const email_newsletter_lsit_blog = document.querySelector('#newsletter-form-blog [name="contact[email]"]').value;
        const errorMessage = document.querySelector('.newsletter-form__message--error-blog');
        const errorMessageEle = document.querySelector('.newsletter-form__message--error-blog .error-msg');
        const emailBlankMessage = errorMessage.dataset.emailBlank;
        const emailInvalidMessage = errorMessage.dataset.emailInvalid;

        // Disable button immediately
        button.disabled = true;

        // Helper functions
        function showError(message) {
            errorMessageEle.textContent = message;
            errorMessage.style.display = 'flex';
            button.disabled = false;
        }

        function hideError() {
            errorMessage.style.display = 'none';
            errorMessageEle.textContent = '';
        }

        hideError();

        // Blank email
        if (email_newsletter_lsit_blog === '') {
            showError(emailBlankMessage);
            return;
        }

        // Invalid email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email_newsletter_lsit_blog)) {
            showError(emailInvalidMessage);
            return;
        }

        const pageLanguage_blog = Shopify.locale; // 'de', 'fr', 'it'
        const klaviyoLists_blog = {
            de: 'Rnns4L',
            fr: 'V4jXu2',
            it: 'RcZbnw'
        };

        var targetListId_blog = klaviyoLists_blog[pageLanguage_blog];
        if (targetListId_blog == undefined || targetListId_blog == '')
            targetListId_blog = 'RcZbnw';

        const response_blog = fetch('https://practicals.equest.solutions/Eusphera/subscribe.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                email: email_newsletter_lsit_blog,
                listId: targetListId_blog
            })
        })
            .then(res => res.json())
            .then(data => {
                var success_redirect = '?customer_posted=true#newsletter-form-blog';
                if (data.success) {
                    // Redirect after successful subscription
                    // window.location.href = window.location.pathname + success_redirect;                
                    document.querySelector('.newsletter-form__message--success-blog').style.display = 'block';
                    document.querySelector('#newsletter-form-blog [name="contact[email]"]').value = '';
                    setTimeout(() => {
                        document.querySelector('.newsletter-form__message--success-blog').style.display = 'none';
                        button.disabled = false;
                    }, 4000);
                } else if (!data.success) {
                    alert(data.error); // optional: show error
                }
            })
            .catch(err => console.error(err));
    });

    // fetch('https://api.trustpilot.com/v1/business-units/YOUR_BUID', {
    //     headers: {
    //         'Authorization': 'apikey YOUR_API_KEY'
    //     }
    // })
    // .then(response => response.json())
    // .then(data => {
    //      document.getElementById('trust-score').innerText = data.trustScore;
    // });
    updateProgressBar();

    $('.idea-wellbeing .benifit-card-grid').owlCarousel({
        margin: 16,
        loop: false,
        dots: true,
        nav: true,
        items: 3,
        responsive: {
            0: {
                items: 1,
                nav: true,
                nav: false
            },
            576: {
                items: 2,
                nav: true,
                nav: false
            },
            1200: {
                items: 3,
                nav: true
            }
        }
    })

    const canvas = document.getElementById('circleCanvas');
    if (canvas) {
        const ctx = canvas.getContext('2d');
        const wrapper = document.getElementById('circleWrapper');

        let rotation = 0, targetRotation = 0, rotating = false;
        const pointCount = 5;
        const titles = canvas.getAttribute('data-heading').split(',');
        const descriptions = canvas.getAttribute('data-content').split(',');
        const margin = 80;
        const rotateDuration = 300;

        function setLetterSpacing(ctx, spacingEm) {
            const fontSize = parseFloat(ctx.font);
            ctx.letterSpacing = (fontSize * spacingEm) + 'px';
        }

        function drawWrappedText(ctx, text, x, y, maxWidth, lineHeight) {
            const words = text.split(' ');
            let line = '', lines = [];
            for (let n = 0; n < words.length; n++) {
                const testLine = line + words[n] + ' ';
                if (ctx.measureText(testLine).width > maxWidth && n > 0) {
                    lines.push(line.trim());
                    line = words[n] + ' ';
                } else {
                    line = testLine;
                }
            }
            lines.push(line.trim());
            for (let i = 0; i < lines.length; i++) {
                ctx.fillText(lines[i], x, y + i * lineHeight);
            }
        }

        function drawCircle() {
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width;
            canvas.height = window.innerHeight * 0.85 + 100;

            const radius = canvas.width / 2 - margin;
            const cx = canvas.width / 2;
            const cy = radius + margin;

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            ctx.beginPath();
            ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
            ctx.strokeStyle = '#fff';
            ctx.lineWidth = 2;
            ctx.stroke();

            const startAngle = -Math.PI / 2 + rotation;

            for (let i = 0; i < pointCount; i++) {
                const angle = startAngle + i / pointCount * 2 * Math.PI;

                // point
                const px = cx + radius * Math.cos(angle);
                const py = cy + radius * Math.sin(angle);
                ctx.beginPath();
                ctx.arc(px, py, 8, 0, 2 * Math.PI);
                ctx.fillStyle = '#FFCB4F';
                ctx.fill();

                // number circle
                const nx = cx + (radius + 50) * Math.cos(angle);
                const ny = cy + (radius + 50) * Math.sin(angle);
                ctx.beginPath();
                ctx.arc(nx, ny, 27, 0, 2 * Math.PI);
                ctx.strokeStyle = '#F2F4F5';
                ctx.lineWidth = 1;
                ctx.stroke();

                ctx.save();
                ctx.translate(nx, ny);
                ctx.fillStyle = '#F2F4F5';
                ctx.font = '22px "DM Sans", sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(i + 1, 0, 0);
                ctx.restore();

                const titleDistance = 150;
                const lineStartX = cx + (radius - 30) * Math.cos(angle);
                const lineStartY = cy + (radius - 30) * Math.sin(angle);
                const lineEndX = cx + (radius - titleDistance + 30) * Math.cos(angle);
                const lineEndY = cy + (radius - titleDistance + 30) * Math.sin(angle);
                ctx.beginPath();
                ctx.moveTo(lineStartX, lineStartY);
                ctx.lineTo(lineEndX, lineEndY);
                ctx.strokeStyle = '#FFF';
                ctx.lineWidth = 1;
                ctx.stroke();

                const tx = cx + (radius - titleDistance) * Math.cos(angle);
                const ty = cy + (radius - titleDistance) * Math.sin(angle);

                ctx.save();
                ctx.translate(tx, ty);
                ctx.rotate(angle + Math.PI / 2);
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillStyle = '#FFF';

                ctx.font = '40px Century Gothic';
                setLetterSpacing(ctx, -0.01);
                ctx.fillText(titles[i], 0, 0);

                ctx.font = '16px "DM Sans", sans-serif';
                setLetterSpacing(ctx, -0.01);
                drawWrappedText(ctx, descriptions[i], 0, 35, 250, 20);
                ctx.restore();
            }
        }

        let lastTime = 0;
        function animate(time) {
            if (!lastTime) lastTime = time;
            const delta = time - lastTime;
            lastTime = time;

            if (rotating) {
                const diff = targetRotation - rotation;
                const step = diff * Math.min(delta / rotateDuration, 1);
                rotation += step;

                if (Math.abs(rotation - targetRotation) < 0.001) {
                    rotation = targetRotation;
                    rotating = false;
                }
            }

            drawCircle();
            requestAnimationFrame(animate);
        }

        // 🔹 Desktop: rotate on scroll
        wrapper.addEventListener('wheel', (e) => {
            if (!rotating) {
                const direction = e.deltaY > 0 ? 1 : -1;
                const stepAngle = (2 * Math.PI / pointCount) * direction;
                targetRotation += stepAngle;
                rotating = true;
            }
        });

        // 🔹 Mobile autoplay logic
        let autoRotateInterval = null;
        const isMobile = window.matchMedia('(max-width: 1025px)').matches;

        if (isMobile) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Start autoplay
                        if (!autoRotateInterval) {
                            autoRotateInterval = setInterval(() => {
                                if (!rotating) {
                                    const stepAngle = 2 * Math.PI / pointCount;
                                    targetRotation += stepAngle;
                                    rotating = true;
                                }
                            }, 2000); // every 2 seconds
                        }
                    } else {
                        // Stop autoplay
                        if (autoRotateInterval) {
                            clearInterval(autoRotateInterval);
                            autoRotateInterval = null;
                        }
                    }
                });
            }, { threshold: 0.5 }); // triggers when 50% in view

            observer.observe(wrapper);
        }

        animate();
        window.addEventListener('resize', drawCircle);
    }



    if (window.location.href.includes('blogs') && window.location.href.includes('/tagged/') && !window.location.href.includes('customer_posted')) {
        // Delay slightly to ensure content is rendered
        setTimeout(function () {
            const target = $('.blog-category-section');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 600); // scroll duration in ms
            }
        }, 300); // delay to wait for DOM rendering
    }

    $('#language-selector-btn').on('click', function () {
        $('#localizationModal').fadeIn();
        $('body').addClass('overflow-hidden');
    });

    $('#closelocalizationModalBtn svg').on('click', function () {
        $('#localizationModal').fadeOut();
        $('body').removeClass('overflow-hidden');
    });

});

(function () {
    const originalFetch = window.fetch;
    window.fetch = async function (url, options) {
        const response = await originalFetch(url, options);

        // Only run for cart updates (add, change, update, etc.)
        if (url.includes('/cart') && url.includes('cart-drawer') ) {
            // Wait for the response to finish and DOM to update
            setTimeout(() => {
                if (typeof updateProgressBar === 'function') updateProgressBar();
                if (typeof updateProgressBar === 'function') loadCartDrawerProducts();
                // If you have discount event bindings, call them here
                if (typeof bindDiscountEvents === 'function') bindDiscountEvents();
                if (typeof rebindDiscountRemove === 'function') rebindDiscountRemove();
            }, 100);
        }
        // if (url.includes('/products') && url.includes('?variant=')) {
        //     setTimeout(() => {
        //         updateProductCarausals();
        //     }, 50);
        // }
        return response;
    };
})();

// Function to update the total price section
function updateTotalPrice() {
    // Select the app's total price container using a class name that starts with 'totalBox_price_container_'
    const appTotalPriceContainers = document.querySelector('[class^="totalBox_price_container_"]');
    const customPriceContainer = document.querySelector('.price-total');
    if (appTotalPriceContainers != undefined) {

        // Extract the discounted and raw prices from the first container
        const discountedPrice = appTotalPriceContainers.querySelector('[class^="totalBox_discounted_price_"]');
        const rawPrice = appTotalPriceContainers.querySelector('[class^="totalBox_raw_price_"]');

        // if (!discountedPrice || !rawPrice) {
        //     console.error('Discounted or raw price not found');
        //     return;
        // }

        // Update the custom price container with the app's prices
        if (customPriceContainer != undefined) {
            customPriceContainer.querySelector('.variant-price').innerHTML = discountedPrice ? discountedPrice.innerHTML : '€0,00';

            if (rawPrice) {
                customPriceContainer.querySelector('.variant-compareprice').innerHTML = rawPrice?.innerHTML;
                customPriceContainer.querySelector('.variant-compareprice').classList.remove('hidden');

                var raw_bundle_comapre_price = customPriceContainer.querySelector('.variant-compareprice').innerHTML.trim();
                var currency_symbol_comapre_price = raw_bundle_comapre_price.replace(/[\d,\.]/g, '').trim();
                var bundle_comapre_price = raw_bundle_comapre_price.replace(/[^\d,\.]/g, '');
                if (bundle_comapre_price.includes(',') && !bundle_comapre_price.includes('.')) {
                    bundle_comapre_price = bundle_comapre_price.replace(',', '.');
                }
                var raw_bundle_price = customPriceContainer.querySelector('.variant-price').innerHTML.trim();
                var bundle_price = raw_bundle_price.replace(/[^\d,\.]/g, '');
                if (bundle_price.includes(',') && !bundle_price.includes('.')) {
                    bundle_price = bundle_price.replace(',', '.');
                }
                // var percentChange = ((bundle_comapre_price - bundle_price) / bundle_price) * 100;
                var discount = bundle_comapre_price - bundle_price;
                var percentChange = (discount / bundle_comapre_price) * 100;
                document.querySelector('.bundle-discount.products-labels .label-discount span').innerHTML = Math.ceil(percentChange);
                document.querySelector('.bundle-discount.products-labels').style.display = 'block';
            } else {
                customPriceContainer.querySelector('.variant-compareprice').classList.add('hidden');
                document.querySelector('.bundle-discount.products-labels').style.display = 'none';
            }
        }
    } else {
        if (customPriceContainer != undefined) {
            customPriceContainer.querySelector('.variant-price').innerHTML = customPriceContainer.querySelector('[data-default-price]').dataset.defaultPrice;
            customPriceContainer.querySelector('.variant-compareprice').classList.add('hidden');
        }
    }
}

function fetchBundleCardHtml(handle) {
    const url = `/products/${handle}?view=bundle-card`;

    return fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'text/html',
            'Content-Type': 'text/html'
        }
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.text();
        })
        .then(htmlString => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const bundleDiv = doc.querySelector('div.bundle-card');
            if (bundleDiv) {
                return bundleDiv.innerHTML;
            } else {
                throw new Error('bundle-card div not found in fetched HTML');
            }
        });
}

// document.addEventListener("DOMContentLoaded", () => {
//   const container = document.querySelector('.who-are-content h3'); // safe selector
//   const words = container.textContent.trim()
//     .split(/\s+/)
//     .map(word => `<span>${word}</span>`)
//     .join(' ');
//   container.innerHTML = words;

//   gsap.registerPlugin(ScrollTrigger);

//   gsap.fromTo(".who-are-content span",
//     { color: "#313131" },
//     {
//       color: "#F2F4F5",
//       stagger: 0.1,
//       scrollTrigger: {
//         trigger: ".who-are-content h3",
//         start: "end 80%",
//         end: "center 20%",
//         scrub: true
//       }
//     }
//   );
// });


document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.querySelector('#load-more');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function () {
            const nextPageUrl = this.dataset.nextUrl;
            if (!nextPageUrl) return;

            this.disabled = true;
            this.innerText = 'Loading...';

            fetch(nextPageUrl)
                .then((res) => res.text())
                .then((data) => {
                    const parser = new DOMParser();
                    const htmlDocument = parser.parseFromString(data, 'text/html');

                    const newItems = htmlDocument.querySelectorAll('#product-grid .grid__item');
                    const container = document.querySelector('#product-grid');

                    newItems.forEach((item) => {
                        container.appendChild(item);
                    });

                    setTimeout(() => {

                        if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
                            // Re-scan the DOM for Trustpilot widgets
                            document.querySelectorAll('.trustpilot-widget').forEach(function (el) {
                                Trustpilot.loadFromElement(el, true);
                            });
                        }
                    }, 500);

                    // Update or remove Load More button
                    const newNextUrl = htmlDocument.querySelector('#load-more')?.dataset.nextUrl;
                    if (newNextUrl) {
                        loadMoreButton.dataset.nextUrl = newNextUrl;
                        loadMoreButton.disabled = false;
                        loadMoreButton.innerText = 'Show More Products';
                    } else {
                        loadMoreButton.remove(); // No more pages
                    }
                })
                .catch((err) => {
                    console.error('Error loading more products:', err);
                });
        });
    }
});
const loadCartDrawerProducts = () => {
    console.log('cart-drawer-products ... ')
    // Destroy existing carousel if already initialized
    if ($('#cart-drawer-products')) {
        // if ($('#cart-drawer-products').hasClass('owl-loaded')) {
        //     $('#cart-drawer-products').trigger('destroy.owl.carousel');
        //     $('#cart-drawer-products').removeClass('owl-carousel owl-loaded');
        //     $('#cart-drawer-products').find('.owl-stage-outer').children().unwrap();
        // }
        // Re-initialize carousel
        $('#cart-drawer-products').addClass('owl-carousel').owlCarousel({
            margin: 8,
            loop: false,
            dots: false,
            nav: false,
            items: 1,
            touchDrag: true,
            mouseDrag: true,
            startPosition: 0,
            responsive: {
                530: {
                    margin: 16,
                    dots: true,
                    nav: true,
                    items: 1,
                    touchDrag: false,
                    mouseDrag: false,
                }
            }
        });

        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                const count = cart.item_count;
                document.querySelector('.cart-count-bubble span') && 
                (document.querySelector('.cart-count-bubble span').textContent = cart.item_count);

                document.querySelector('.cart-count-bubble') && 
                (document.querySelector('.cart-count-bubble').setAttribute('data-item-count', cart.item_count));
            })
            .catch(error => {
                console.error('Error fetching cart count:', error);
            });
        syncQuickAddedSessionsWithCart();

    }
}

// Utility: Get all sessionStorage keys starting with prefix
function getSessionKeysByPrefix(prefix) {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith(prefix)) {
            keys.push(key);
        }
    }
    return keys;
}

// Call this function after cart drawer updates
function syncQuickAddedSessionsWithCart() {
    // 1. Get all sessionStorage keys starting with "quick_added_"
    const sessionKeys = getSessionKeysByPrefix('quick_added_');

    // 2. Get all current variant IDs in cart drawer
    // Assuming each cart line item has attribute 'data-variant-id'
    const variantElements = document.querySelectorAll('.cart-remove-button[data-variant-id]');
    const variantIdsInCart = Array.from(variantElements).map(el => el.getAttribute('data-variant-id'));


    // 3. Loop session keys, extract variantId, check if still present in cart
    sessionKeys.forEach(key => {
        // Key format: "quick_added_<variantId>"
        const variantId = key.replace('quick_added_', '');

        if (!variantIdsInCart.includes(variantId)) {
            // Variant not in cart drawer anymore → remove session
            sessionStorage.removeItem(key);
            removeAddedToCartClassIfVariantNotInCart(variantId);
            console.log(`Removed sessionStorage key: ${key}`);
        }
    });
}
function removeAddedToCartClassIfVariantNotInCart(variantIdFun) {
    // 1. Use passed-in function to get current cart variant IDs
    const cartVariantIds = typeof variantIdFun === 'function' ? variantIdFun() : [];

    // 2. Loop through all .quick-cart.added-to-cart elements
    const quickCartElements = document.querySelectorAll('.quick-cart.added-to-cart');

    quickCartElements.forEach(quickCart => {
        const productForm = quickCart.querySelector('product-form');
        const variantId = productForm?.getAttribute('data-variant-id');

        if (variantId && !cartVariantIds.includes(variantId)) {
            quickCart.classList.remove('added-to-cart');
            quickCart.querySelector('.addtocart-icon').classList.remove('hidden');
            quickCart.querySelector('.success-added').classList.add('hidden');
            console.log(`Removed 'added-to-cart' from .quick-cart for variant ${variantId}`);
        }
    });
}
// const updateProgressBar = () => {

//     const progressBar = document.querySelectorAll('.progress-bar');
//     if (!progressBar) return;
//     progressBar.forEach(progressElement => {
//         const progressFill = progressElement.querySelector('.progress-fill');
//         const cartTotal = parseFloat(progressElement.getAttribute('data-cart-total'));
//         const freeShippingThreshold = parseFloat(progressElement.getAttribute('data-free-shipping-threshold'));
//         const sampleThreshold = parseFloat(progressElement.getAttribute('data-sample-threshold'));
//         const minThreshold = parseFloat(progressElement.getAttribute('data-min-threshold'));

//         let progressPercentage = 0;
//         if (cartTotal > 0) {
//             if (cartTotal >= freeShippingThreshold) {
//                 progressPercentage = 100;
//             } else if (cartTotal >= sampleThreshold) {
//                 progressPercentage = ((cartTotal - sampleThreshold) / (freeShippingThreshold - sampleThreshold)) * 50 + 50;
//             } else if (cartTotal >= minThreshold) {
//                 progressPercentage = ((cartTotal - minThreshold) / (sampleThreshold - minThreshold)) * 50;
//             }

//             progressFill.style.width = progressPercentage + '%';

//             document.querySelectorAll('.progress-step').forEach(step => {
//                 step.classList.remove('active');
//             });

//             document.querySelectorAll('.progress-step').forEach(step => {
//                 const stepAmount = parseFloat(step.getAttribute('data-amount'));
//                 if (cartTotal >= stepAmount) {
//                     step.classList.add('active');
//                 }
//             });
//         } else {
//             document.querySelectorAll('.progress-step').forEach(step => {
//                 step.classList.remove('active');
//             });
//         }
//     });
// }

// const updateProgressBar = () => {
//   const progressBars = document.querySelectorAll('.progress-bar');
//   if (!progressBars.length) return;

//   progressBars.forEach(progressElement => {
//     const progressFill = progressElement.querySelector('.progress-fill');
//     const cartTotal = parseFloat(progressElement.dataset.cartTotal || 0);
//     var initalText = progressElement.getAttribute('data-first-default-text');
//     var addText = progressElement.getAttribute('data-add-text');
//     var forText = progressElement.getAttribute('data-for-text');

//     const milestones = [
//       {
//         limit: parseFloat(progressElement.getAttribute('data-free-samples-limit') || 0),
//         threshold: parseFloat(progressElement.getAttribute('data-free-samples-threshold') || 0),
//         text: progressElement.getAttribute('data-free-samples-text')
//       },
//       {
//         limit: parseFloat(progressElement.getAttribute('data-free-shipping-limit') || 0),
//         threshold: parseFloat(progressElement.getAttribute('data-free-shipping-threshold') || 0),
//         text: progressElement.getAttribute('data-free-shipping-text')
//       },
//       {
//         limit: parseFloat(progressElement.getAttribute('data-custom-step-1-limit') || 0),
//         threshold: parseFloat(progressElement.getAttribute('data-custom-step-1-threshold') || 0),
//         text: progressElement.getAttribute('data-custom-step-1-text')
//       },
//       {
//         limit: parseFloat(progressElement.getAttribute('data-custom-step-2-limit') || 0),
//         threshold: parseFloat(progressElement.getAttribute('data-custom-step-2-threshold') || 0),
//         text: progressElement.getAttribute('data-custom-step-2-text')
//       }
//     ].filter(m => m.limit > 0 && m.threshold > 0);

//     const translate = (key) => {
//         return window?.translations?.[key] || key;
//     }


//     // Sort milestones by limit (ascending)
//     milestones.sort((a, b) => a.limit - b.limit);
//     if (!milestones.length) return;

//     // ✅ Find the highest milestone (for full 100% fill)
//     const maxMilestone = milestones[milestones.length - 1];
//     const maxLimit = maxMilestone.limit;
//     const maxText = maxMilestone.text;

//     // ✅ Calculate fill % based on max milestone
//     let progressPercentage = (cartTotal / maxLimit) * 100;
//     if (cartTotal >= maxLimit) progressPercentage = 100;

//     progressFill.style.width = `${Math.min(progressPercentage, 100)}%`;

//     // ✅ Activate steps dynamically
//     progressElement.querySelectorAll('.progress-step').forEach(step => {
//       const stepAmount = parseFloat(step.dataset.amount || 0);
//       step.classList.toggle('active', cartTotal >= stepAmount);
//     });

//     // ✅ Calculate remaining amount for the max milestone
//     const remaining = maxLimit - cartTotal;
//     const formattedRemaining = remaining > 0 ? remaining.toFixed(2) : 0;

//     // ✅ Inject text into FIRST step (first .progress-step)
//     // if (cartTotal > 0) {
//     // const firstStep = progressElement.querySelector('.progress-step.first-step .step-description');
//     // if (firstStep) {
//     //   if (remaining > 0) {
//     //     firstStep.innerHTML = `
//     //       <span class="money">${addText} €${formattedRemaining}</span><br>
//     //        ${forText} ${maxText}
//     //     `;
//     //     firstStep.style.display = 'block';
//     //   } else {
//     //     firstStep.style.display = 'none';
//     //     // firstStep.innerHTML = `
//     //     //   <span class="money">🎉</span><br>
//     //     //   ${maxText} unlocked!
//     //     // `;
//     //   }
//     // }
//     // } else {
//     //     const firstStep = progressElement.querySelector('.progress-step.first-step .step-description');
//     //     if (firstStep) {
//     //          firstStep.innerHTML = `${initalText}
//     //         `;
//     //         firstStep.style.display = 'block';
//     //     }
//     // }
//   });
// };

const updateProgressBar = () => {
  const progressBars = document.querySelectorAll('.progress-bar');
  if (!progressBars.length) return;

  progressBars.forEach(progressElement => {
    const progressFill = progressElement.querySelector('.progress-fill');
    const cartTotal = parseFloat(progressElement.dataset.cartTotal || 0);

    const addText = progressElement.dataset.addText;
    const forText = progressElement.dataset.forText;
    const initialText = progressElement.dataset.firstDefaultText;

    // Load correct milestone keys
    const milestones = [
      {
        limit: parseFloat(progressElement.dataset.freeSamplesLimit || 0),
        threshold: parseFloat(progressElement.dataset.freeSamplesThreshold || 0),
        text: progressElement.dataset.freeSamplesText
      },
      {
        limit: parseFloat(progressElement.dataset.freeShippingLimit || 0),
        threshold: parseFloat(progressElement.dataset.freeShippingThreshold || 0),
        text: progressElement.dataset.freeShippingText
      },
      {
        limit: parseFloat(progressElement.dataset.customStepFirstLimit || 0),
        threshold: parseFloat(progressElement.dataset.customStepFirstThreshold || 0),
        text: progressElement.dataset.customStepFirstText
      },
      {
        limit: parseFloat(progressElement.dataset.customStepSecondLimit || 0),
        threshold: parseFloat(progressElement.dataset.customStepSecondThreshold || 0),
        text: progressElement.dataset.customStepSecondText
      }
    ].filter(m => m.limit > 0 && m.threshold > 0); // FIXED

    if (!milestones.length) return;

    // sort milestones
    milestones.sort((a, b) => a.limit - b.limit);

    // find previous + next milestone
    let nextMilestone = milestones.find(m => cartTotal < m.limit);
    let prevMilestone = null;

    if (nextMilestone) {
      const index = milestones.indexOf(nextMilestone);
      prevMilestone = index > 0 ? milestones[index - 1] : { limit: 0, threshold: 0 };
    }

    const firstStep = progressElement.querySelector('.progress-step.first-step .step-description');

    // If all milestones completed
    if (!nextMilestone) {
      progressFill.style.width = "100%";
      firstStep.style.display = "none";
      progressElement.querySelectorAll('.progress-step').forEach(step => step.classList.add('active'));
      return;
    }

    // Calculate progress between prev and next
    const range = nextMilestone.limit - prevMilestone.limit;
    const progressed = cartTotal - prevMilestone.limit;
    const part = progressed / range;

    let basePercent = prevMilestone.threshold + (part * (nextMilestone.threshold - prevMilestone.threshold));

    // Prevent crossing next milestone threshold
    const finalPercent = Math.min(basePercent, nextMilestone.threshold);

    progressFill.style.width = `${finalPercent}%`;

    // Activate steps
    progressElement.querySelectorAll('.progress-step').forEach(step => {
      const stepAmount = parseFloat(step.dataset.amount || 0);
      step.classList.toggle('active', cartTotal >= stepAmount);
    });

    // Update label text
    const remaining = nextMilestone.limit - cartTotal;

    if (cartTotal === 0) {
      firstStep.textContent = initialText;
      firstStep.style.display = "block";
    } else {
      firstStep.innerHTML = `
        <span class="money">${addText} €${remaining.toFixed(2)}</span><br>
        ${forText} ${nextMilestone.text}
      `;
      firstStep.style.display = "block";
    }
  });
};

const updateProductCarausals = () => {
    console.log('Initializing product carousels...');
    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 8;
    var syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: true,
        autoplay: false,
        dots: false,
        loop: false,
        responsiveRefreshRate: 200,
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
    }).on('changed.owl.carousel', syncPosition);

    sync2
        .on('initialized.owl.carousel', function () {
            sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
            items: slidesPerPage,
            dots: false,
            nav: false,
            smartSpeed: 200,
            slideSpeed: 500,
            margin: 5,
            autoWidth: true,
            slideBy: slidesPerPage,
            responsiveRefreshRate: 100
        }).on('changed.owl.carousel', syncPosition2);

    // function syncPosition(el) {
    //     var count = el.item.count - 1;
    //     var current = Math.round(el.item.index - (el.item.count / 2) - .5);

    //     if (current < 0) {
    //         current = count;
    //     }
    //     if (current > count) {
    //         current = 0;
    //     }

    //     sync2
    //         .find(".owl-item")
    //         .removeClass("current")
    //         .eq(current)
    //         .addClass("current");
    //     var onscreen = sync2.find('.owl-item.active').length - 1;
    //     var start = sync2.find('.owl-item.active').first().index();
    //     var end = sync2.find('.owl-item.active').last().index();

    //     if (current > end) {
    //         sync2.data('owl.carousel').to(current, 100, true);
    //     }
    //     if (current < start) {
    //         sync2.data('owl.carousel').to(current - onscreen, 100, true);
    //     }
    // }


    function syncPosition(el) {
        var carousel = el.relatedTarget;
        var current;

        if (carousel.options.loop) {
            // loop mode (original behavior)
            var count = carousel.items().length - 1;
            current = Math.round(el.item.index - (el.item.count / 2) - .5);

            if (current < 0) current = count;
            if (current > count) current = 0;
        } else {
            // non-loop mode
            current = el.item.index;
        }

        sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });
}

window.updateProductCarausals = updateProductCarausals; 

// $(document).ready(function () {
//     if($('body').hasClass('product')) {
//         setTimeout(() => {
//             console.log('gallery', $('.product-gallery'));
//             $('.product-gallery').addClass('show');
//             let productGalleryCarausal = setInterval(() => {
//                 console.log('gallery interval');
//                 if ($('.product-gallery').hasClass('show')) {
//                     console.log('gallery if');
//                     updateProductCarausals();
//                     clearInterval(productGalleryCarausal);
//                 } else {
//                     $('.product-gallery').addClass('show');
//                     console.log('gallery else');
//                 }
//             }, 50);
//         }, 2200);
//     }
// })